import * as _ from 'lodash';
// app services
import { AuthService } from '../../../api/auth.service';
import { LangService } from '../../../core/lang.service';
import { RoutesService } from '../../../api/routes.service';
import { ScriptGenService } from '../../script-gen.service';
import { ItemFilterCtrl } from './item-filter';
import { ItemBankCtrl } from './item-bank';
import {
  collectAndEnsureEntryIds,
  getQuestionConfiguredEA,
  identifyQuestionResponseEntries
} from '../models/expected-answer';
import { ItemSetFrameworkCtrl } from './framework';
import { ElementType, getElementWeight, IContentElement,  IQuestionConfig, IScoredResponse, ScoringTypes, } from '../../../ui-testrunner/models';
import { PARAM_SPECIAL_FLAGS } from '../../framework-dimension-editor/model';
import { FrameworkQuadrantCtrl } from './quadrants';
import { getElementChildren, ExpectedAnswer} from '../models';
import { EStatus, ILibraryAsset} from '../../asset-details/types'
import { IAssembledPanel, IPanelModuleConfig, IPanelModulesConfig, IQuadrantTestlet, TestFormConstructionMethod } from '../models/assessment-framework';
import { IContentElementMcq, IEntryStateMcq, McqDisplay, mcqOptionLabels } from '../../../ui-testrunner/element-render-mcq/model';
import { IContentElementInput, InputFormat } from '../../../ui-testrunner/element-render-input/model';
import { ElementTypeDefs } from '../../../ui-testrunner/models/ElementTypeDefs';
import { TextParagraphStyle } from 'src/app/ui-testrunner/element-render-text/model';
import { Destroyable } from './destroyable';
import { ItemEditCtrl } from './item-edit';

import { IContentElementSelectionTable } from '../../../ui-testrunner/element-render-selection-table/model';
import { IContentElementMoveableDragDrop } from '../../../ui-testrunner/element-render-moveable-dnd/model';
import { IContentElementDndDraggable } from '../../../ui-testrunner/element-render-dnd/model';
import { IContentElementGroup } from '../../../ui-testrunner/element-render-grouping/model';
import { IContentElementVideo } from '../../../ui-testrunner/element-render-video/model';
import { IContentElementImage } from '../../../ui-testrunner/element-render-image/model';
import { IContentElementAudio } from '../../../ui-testrunner/element-render-audio/model';
import { IContentElementMcqOption } from 'src/app/ui-testrunner/element-render-mcq/model';
import { IAuditConfig, EAuditElementType, IAuditFilterScopedQuestions, AuditQuestionScope, EItemTypesParam, ITEM_MAP_MODULE_META_AUDIT_CONST_LABELS, AuditTarget, AuditType, ICheckPropVal, ICheckProp, ParamCheckTypes, AuditCheckType, AuditPanelTargets, AuditMetaRecord, AuditAssesmentTypeFlags, IQuestionScoreCategory, TestletRequiredTargets, PANEL_AUDIT_TYPE_TO_TARGET_DICT, ETEITypesParam, EFilterMethods, TAuditCheck, IAuditCheckByFunctions } from 'src/app/ui-item-maker/widget-audits/data/audits'
import { processCheck, IAuditResult, AuditResultCore, AuditResultMeta, proccessInformativeOnly, getCloneLabelCore, filterArray, processCompositeCheck, processCheckByFunction } from 'src/app/ui-item-maker/widget-audits/util/checks';
import { applyItemFilter, checkQuestionInScope, getQuestionByLang, getQuestionsByScope, getScreens, IContext } from 'src/app/ui-item-maker/widget-audits/util/item-scopes';
import { itemContentDiff, legacyItemContentDiff } from 'src/app/ui-item-maker/widget-audits/util/content-diff';
import { checkPropCondVal, countKeyValues, getQuestionContent, getQuestionDeepElements, getQuestionPoints, getQuestionRespondableDeep, isNullOrEmptyOrUndefined, splitLettersNumbers } from 'src/app/ui-item-maker/widget-audits/util/content-analysis';
import { processPatch } from '../../widget-audits/util/patches';
import { IExpansionPanelContent,ExpansionPanelContentType } from 'src/app/ui-partial/expansion-panel/expansion-panel.component';
import { IContentElementTemplate } from 'src/app/ui-testrunner/element-render-template/model';
import getAssetSize from 'src/app/ui-item-maker/widget-audits/util/get-asset-size';
import { scoreMatrixElementTypes } from '../../config-score-matrix/models';
import { QuestionView } from '../item-set-editor.component';
import { BehaviorSubject, of, Subscription } from 'rxjs';
import { LoginGuardService } from 'src/app/api/login-guard.service';
import { ExcludedAuditEntry, ExcludedAuditsMap, getDefaultExcludedAuditEntry } from '../../view-im-audits/view-im-audits.component';
import { ItemMakerService } from '../../item-maker.service';
import { deepFindAll } from '../../services/util';
import { aggregateAuditMetaRecords } from '../../widget-audits/util/overall-status';
import { auditTypeWithoutSummary } from '../../widget-audits/audit-table/audit-table.component';
import { AuditCacheService } from '../../services/audit-cache.service';
import { psychStatDataCol, psychThresholdParams, sanitizePsychStats } from '../../widget-audits/util/psychStats';
import { ECheckCache, ECheckFunctionIds, TCheckCache, TCheckCacheType, TCheckFunctionType } from '../../widget-audits/data/checks';

export interface IAuditFormattedResult {
  id: string
  caption: string;
  isAutoFixable?: boolean;
  items: any[];
  num_issues: number;
  informativeOnly?: boolean;
  isHidden?: boolean;
}

/**
 * Used for preview data of the audit status
 * 
 */
export interface IAuditResultSummary {
  pass: number,
  fail: number,
  informative: number,
  lastRan?: number,
  firstRan?: number,
}

export enum AuditResultType {
  ITEM = "ITEM",
  FRAMEWORK = "FRAMEWORK",
  OVERALL = "OVERALL",
  DEFAULT = ''
}
export interface IAssetResult {
  size: number;
  url?: string;
  entryId?: number; 
  type?: ElementType | string;
}
interface IQuestionResult {
  qid: number;
  results: IAssetResult[];
  totalSize: number;
  imageSize: number;
  audioSize: number;
}



enum AuditErrors {
  INVALID_ASSESMENT_TYPE = 'INVALID_ASSESMENT_TYPE',
  NO_PANELS_TO_AUDIT = 'NO_PANELS_TO_AUDIT',
  INVALID_USER_INPUT = 'INVALID_USER_INPUT'
}

export type AuditMem = {[memId: string]: any, __metaData?: IAuditResultSummary};

export class ItemBankAuditor implements Destroyable {
  
  voiceoverAuditResults;
  
  audits: IAuditConfig[];
  auditsFixProgress: {[key: string]: {count: number, total: number}} = {};
  auditQuestionMem: AuditMem = {};
  activeAuditItemMemId: string;
  auditResultHeader = new Map<string, string>();
  auditItemListingMode:AuditTarget;
  excludedAuditMap: ExcludedAuditsMap = {};

  auditFilterScopedQuestions: IAuditFilterScopedQuestions = {
    [AuditQuestionScope.SCREENS]: true,
    [AuditQuestionScope.SCREENS_NON_PASSAGES]: false,
    [AuditQuestionScope.SCREENS_PASSAGES]: false,
    [AuditQuestionScope.ITEMS_SCORED]: false,
    [AuditQuestionScope.ITEMS_SURVEY]: false,
    [AuditQuestionScope.ITEM_BANK]: false,
    [AuditQuestionScope.ITEM_BANK_SCORED]: false
  };

  customIterators:{[auditSlug:string] : (auditResultsModel:AuditResultCore, skipDisabled?:boolean) => Promise<AuditResultMeta>} = {};
  customAutoFixes:{[patchSlug:string] : (auditSlug:string, patchSlug:string) => void} = {};
  auditLogs: any[] = [];
  auditsMetadataUpdated: BehaviorSubject<boolean> = new BehaviorSubject(null);
  auditsRunning: {[key: string]: boolean} = {};
  auditsWithError: {[key: string]: boolean} = {};
  runningItemLevelAuditId: number; //? To indicate if currently an item level audit is running
  runningFrameworkLevelAuditId: number;
  public auditRanSub: BehaviorSubject<string> = new BehaviorSubject('');
  public bulkAuditCompleted: BehaviorSubject<boolean> = new BehaviorSubject(false);
  constructor(
    public scriptGen: ScriptGenService,
    public itemFilterCtrl:ItemFilterCtrl,
    public itemBankCtrl:ItemBankCtrl,
    public frameworkCtrl:ItemSetFrameworkCtrl,
    public quadrantCtrl: FrameworkQuadrantCtrl,
    public auth: AuthService,
    public routes: RoutesService,
    private lang: LangService,
    public itemEditCtrl: ItemEditCtrl,
    private loginGuard: LoginGuardService,
    private itemMaker: ItemMakerService,
    private auditCacheService: AuditCacheService,
  ){
    // We'll initialize audits when needed, not in the constructor
  }

  /**
   * Proxy for auditsRan state, now managed by AuditCacheService
   */
  get auditsRan(): { [key: string]: boolean } {
    return this.auditCacheService.auditsRan;
  }
  set auditsRan(val: { [key: string]: boolean }) {
    this.auditCacheService.auditsRan = val;
  }

  destroy() {
    this.clearSubscriptions();
    this.resetAudits();
  }

  clearSubscriptions() {
  }

  /**
   * Note please destroy in your component if calling this
   * @returns 
   */
  clone(): ItemBankAuditor {
    return new ItemBankAuditor(
      this.scriptGen,
      this.itemFilterCtrl,
      this.itemBankCtrl,
      this.frameworkCtrl,
      this.quadrantCtrl,
      this.auth,
      this.routes,
      this.lang,
      this.itemEditCtrl,
      this.loginGuard,
      this.itemMaker,
      this.auditCacheService,
    );
  }

  /**
   * Custom alert function that checks controller state
   * @param str 
   */
  alert(str:string){
    if(!this.runningItemLevelAuditId){ // if running item level don't alert
      this.loginGuard.quickPopup(str)
    } 
  }

  async runCustomCleaningPatch(audit:IAuditConfig, patchSlug:string){
    const auditSlug = audit.slug;
    if (audit.isCompleteFix){
      const patch = audit.autoFixes;
      // const {questions} = await this.renderAuditResultsModel(auditSlug); // todo: sub optimal. should be getting the list of questions from the parent check
      this.runQuestionAutoFixes( patchSlug, [patch.checkCompositeSlug], async (questionFixing: IQuestionConfig) => {
        await processPatch(audit, patch, questionFixing, {
          itemBankCtrl: this.itemBankCtrl,
          frameworkCtrl: this.frameworkCtrl,
        })
      })
    }
    else {
      if (typeof this.customAutoFixes[patchSlug] === 'function') {
        await this.customAutoFixes[patchSlug](auditSlug, patchSlug);
      }
      else {
        this.alert('Cleaning fix is not configured for '+patchSlug)
      }
    }
  }

  lastItemLevelRunBlocked:boolean = false;
  /**
   * Function that runs all audits on a given question
   * @param isAutoRun if it's auto run don't run async and no completion alert 
   * @param question  if you want to run the audit on a specific question else it uses active question
   * @returns 
   */
  async runAllItemLevelAudits(isAutoRun:boolean = false, question?:IQuestionConfig){
    const currentQuestion = getQuestionByLang(question ?? JSON.parse(JSON.stringify(this.itemBankCtrl.currentQuestion)), this.lang.c());
    if(this.runningItemLevelAuditId){ // UI blocks from running multiple but on auto run it might still make it run while it's already running
      this.lastItemLevelRunBlocked = true;
      return;
    } else {
      this.lastItemLevelRunBlocked = false;
    }
    if(!isAutoRun) this.alert('Running Audits for item: ' + currentQuestion.label);
    this.runningItemLevelAuditId = currentQuestion.id;
    let audits = await this.getItemLevelAudits();
    const itemLabel = currentQuestion.label;
    this.runningItemLevelAuditId = currentQuestion.id;
    this.auditLogs = [];
    // Filter audits and update itemResults metadata for async audits if needed
    audits = this.processAuditsAndUpdateMeta(audits, currentQuestion.id, !isAutoRun)

    Promise.all( // don't have to wait to finish
      audits.map(async (audit) =>{
          await this.runCustomAudit(audit.slug, audit.itemScope[0], true, AuditTarget.QUESTIONS, currentQuestion, true); // Todo better handling of audits that run on multiple scopes
          return;
    }))
    .catch()
    .finally(() =>{
      this.finishProcessingItemLevelAudit();
      if(!isAutoRun){
        this.alert(`Completed Running Audits for item: ${itemLabel} (${currentQuestion.id})` );
      }
    });
  }

  runAllAuditProgress = {ran: 0, total: 0};
  async runAllFrameworkLevelAudits(includeAsync: boolean = false, itemSetId: number = +this.itemBankCtrl.customTaskSetId, auditType?: AuditType){
    if(this.runningFrameworkLevelAuditId){ // UI blocks from running multiple but on auto run it might still make it run while it's already running
      this.lastItemLevelRunBlocked = true;
      return;
    } else {
      this.lastItemLevelRunBlocked = false;
    }
    this.runningFrameworkLevelAuditId = itemSetId;
    let audits = await this.getFrameworkLevelAudits(auditType);
    audits = this.processAuditsAndUpdateMeta(audits, itemSetId, includeAsync, auditType);
    this.runAllAuditProgress.total = includeAsync ? audits.length : audits.filter(audit => !audit.isAsync)?.length;
    this.runAllAuditProgress.ran = 0;
    Promise.all( // don't have to wait to finish
      audits.map(async (audit) =>{
          await this.runCustomAudit(audit.slug, audit.itemScope[0], true, audit.auditTarget, null, true); // Todo better handling of audits that run on multiple scopes
          this.runAllAuditProgress.ran++
          return;
    }))
    .catch()
    .finally(() =>{
      this.bulkAuditCompleted.next(true);
      this.finishProcessingFrameworkLevelAudit();
    });
  }

  private processAuditsAndUpdateMeta(
    audits: IAuditConfig[],
    overallMemId: number,
    runAsync: boolean,
    auditType?: AuditType
  ): IAuditConfig[] {
    let itemResults: Record<number, IAuditResultSummary> = {};
    if (auditType) { // save other audit type results and clear the type we're targetting
      itemResults = JSON.parse(JSON.stringify(this.auditQuestionMem[this.getAuditResultSlug(overallMemId, AuditResultType.OVERALL)]));
      delete itemResults[auditType];
    }
    const filteredAudits = audits.filter((audit) => {
      // Ensure itemResults entry for this audit type exists
      if (!itemResults[audit.auditType]) {
        itemResults[audit.auditType] = {
          pass: 0,
          fail: 0,
          informative: 0,
          firstRan: Date.now(),
          lastRan: Date.now(),
        };
      }
      if (auditType && (auditType !== audit.auditType)) {
        return false;
      }
      // Include all audits if not auto-run
      if (runAsync) {
        return true;
      }

      // For async audits during auto-run, skip running them but update metadata
      if (audit.isAsync) {
        const auditMem = this.auditQuestionMem[this.getAuditResultSlug(audit.slug)];
        const meta = auditMem?.__metaData;
        if (meta) {
          const itemMeta = itemResults[audit.auditType];
          itemMeta.pass += meta.pass ?? 0;
          itemMeta.informative += meta.informative ?? 0;
          itemMeta.fail += meta.fail ?? 0;
          itemMeta.firstRan = Math.min(itemMeta.firstRan ?? Infinity, meta.firstRan ?? Infinity);
          itemMeta.lastRan = Math.max(itemMeta.lastRan ?? -Infinity, meta.lastRan ?? -Infinity);
        }
        return false; // skip async audit
      }

      return true; // sync audits pass through
    });

    // Store the results in memory under the provided ID
    this.auditQuestionMem[this.getAuditResultSlug(overallMemId, AuditResultType.OVERALL)] = itemResults;

    return filteredAudits;
  }

  
  async getItemLevelAudits(){
    const auditConfigs = (await this.getActiveAudits())
    ?.filter(audit => { // remove all audits that don't have checks / and all checks that don't have a caption
    audit.checks = audit.checks?.filter(c => c.caption);
    return audit.checks?.length ? audit : null;
    })
    .filter(audit => {
      if(!audit.auditTarget){
        audit.auditTarget = AuditTarget.QUESTIONS
      }
      const isItemLevel = audit?.auditTarget === AuditTarget.QUESTIONS;
      const isEnabled = !audit?.isHidden && !audit?.isDisabled;
      const hasChecks = !!audit?.checks?.length
      return isItemLevel && isEnabled && !audit?.isContentDiff && hasChecks
    });
    return auditConfigs
  }

  async getFrameworkLevelAudits(auditType?:AuditType, includeHidden:boolean = false): Promise<IAuditConfig[]>{
    // Filter audits and mark excluded ones in a single pass
     const auditConfigs = this.audits.filter(audit => {
      // Skip if hidden or disabled
      if(audit.isHidden || audit.isDisabled) {
        // Mark as excluded if not includeHidden
        if (!includeHidden) {
          const auditEntry = this.getExcludedAudit(audit.slug)
          auditEntry.isExcluded = true;
          return false;
        }
      }
      
      // Filter by audit type if specified
      if (auditType && audit.auditType !== auditType) {
        return false;
      }
      
      return true;
    });
    return  this.getActiveAudits(includeHidden, auditConfigs);
  }

  getActiveAuditsByFramework(audits: IAuditConfig[]): IAuditConfig[] {
    const framework = this.frameworkCtrl.asmtFmrk;
    const { testFormType } = framework;
    const isTestletDesign = testFormType === TestFormConstructionMethod.TLOFT || testFormType === TestFormConstructionMethod.MSCAT;
    const dimensions = this.frameworkDimensions
    return audits.filter(audit => {
      const auditSlug = audit.slug;
      const currentExclusion = this.getExcludedAudit(auditSlug);

      const {
        auditTarget,
        requiredFrameworkFlags: requiredFrameworkFlags = [],
        excludedFrameworkFlags: excludedFrameworkFlags = []
      } = {
        ...audit,
        requiredFrameworkFlags: audit.requiredFrameworkFlags ?? [],
        excludedFrameworkFlags: audit.excludedFrameworkFlags ?? []
      };

      const requireTestlets = TestletRequiredTargets.has(auditTarget);
      if(audit.auditType === "DATA" || audit.auditType === "ADIF" || audit.auditType ==='PSYCH'){
        excludedFrameworkFlags.push(AuditAssesmentTypeFlags.PT, AuditAssesmentTypeFlags.IS_RESOURCE_ONLY)
      }

      if (requireTestlets && !isTestletDesign) {
        currentExclusion.isExcluded = true;
        return false;
      }

      let isRequiredFormType = this.checkAuditFrameworkCompliance(requiredFrameworkFlags, excludedFrameworkFlags);
      

      if (audit.requiredFrameworkParamCodes && !audit.requiredFrameworkParamCodes.every(param => dimensions.includes(param))) {
        currentExclusion.isExcluded = true;
        return false;
      }

      let hasRequiredParams = true;
      const someChecksAreParamType = audit.checks && audit.checks.some(check => ParamCheckTypes.includes(check.checkType) || check.requiredFrameworkParamCodes);
      const someChecksHaveFrameworkReqs = audit.checks?.some(check => check.requiredFrameworkFlags || check.excludedFrameworkFlags);
      const commonCheckParams = (audit.commonCheckProps && ParamCheckTypes.includes(audit.commonCheckProps.checkType));
      const reqParamCheck = commonCheckParams || someChecksAreParamType;

      if (reqParamCheck || someChecksHaveFrameworkReqs) {
        hasRequiredParams = !reqParamCheck;
        let commonCheckProps: Partial<TAuditCheck>;

        if (audit.commonCheckProps && ParamCheckTypes.includes(audit.commonCheckProps.checkType)) {
          commonCheckProps = audit.commonCheckProps;
        }

        if (audit.checks?.length) {
          audit.checks.forEach((check) => {
            const checkHasReqParam = this.checkFrameworkHasReqParams(check, commonCheckProps);
            const isRequiredFormTypeCheck = this.checkAuditFrameworkCompliance(check.requiredFrameworkFlags, check.excludedFrameworkFlags);
            if (!checkHasReqParam || !isRequiredFormTypeCheck) {
              check.isHidden = true;
              currentExclusion.excludedChecks[check.id] = true;
            } else {
              hasRequiredParams ||= true;
            }
          });

          audit.checks = audit.checks.filter((check) => !currentExclusion.excludedChecks[check.id]);
        }
      }
      
      audit?.checks?.forEach((check)=>{
        if(check.isHidden) currentExclusion.excludedChecks[check.id] = true;
      })

      const shouldInclude = isRequiredFormType && hasRequiredParams;
      if (!shouldInclude) {
        currentExclusion.isExcluded = true;
      }

      return shouldInclude;
    });
  }

  /**
 * Checks if an audit item meets all required framework flags and none of the excluded flags.
 *
 * @param requiredFrameworkFlags Array of flags that the audit MUST have.
 * @param excludedFrameworkFlags Array of flags that the audit MUST NOT have.
 * @param testFormType The construction method of the test form (e.g., LINEAR, TLOFT, MSCAT).
 * @param isQuestionnaire Boolean flag for questionnaire type.
 * @param isAlternativeLinearTest Boolean flag for alternative linear test type.
 * @param isTestletDesign Boolean flag for testlet design.
 * @param hasPreservedParams Boolean flag for preserved parameters.
 * @param isPractice Boolean flag for practice test.
 * @param isResourceOnly Boolean flag for resource-only item.
 * @returns {boolean} True if the audit item meets all criteria, false otherwise.
 */
  checkAuditFrameworkCompliance(
    requiredFrameworkFlags: (TestFormConstructionMethod | AuditAssesmentTypeFlags)[] = [],
    excludedFrameworkFlags: (TestFormConstructionMethod | AuditAssesmentTypeFlags)[] = [],
  ): boolean {
    const framework = this.frameworkCtrl.asmtFmrk;
    const isQuestionnaire = framework.isQuestionnaireAssessment;
    const isAlternativeLinearTest = framework.isAlternativeLinearTest;
    const isPractice = framework.isSampleTest;
    const isResourceOnly = framework.isResourcePageOnly;
    const { testFormType } = framework;
    const isTestletDesign = testFormType === TestFormConstructionMethod.TLOFT || testFormType === TestFormConstructionMethod.MSCAT;
    const hasPreservedParams = !!framework.preservedMetaParams?.length;
    let isCompliant = true;

    // An audit item is compliant only if it satisfies ALL required flags.
    for (const reqType of requiredFrameworkFlags) {
      switch (reqType) {
        case TestFormConstructionMethod.LINEAR:
          if (testFormType !== TestFormConstructionMethod.LINEAR) isCompliant = false;
          break;
        case TestFormConstructionMethod.TLOFT:
          if (testFormType !== TestFormConstructionMethod.TLOFT) isCompliant = false;
          break;
        case TestFormConstructionMethod.MSCAT:
          if (testFormType !== TestFormConstructionMethod.MSCAT) isCompliant = false;
          break;
        case AuditAssesmentTypeFlags.QUESTIONNAIRE:
          if (!isQuestionnaire) isCompliant = false;
          break;
        case AuditAssesmentTypeFlags.ALTERNATIVE:
          if (!isAlternativeLinearTest) isCompliant = false;
          break;
        case AuditAssesmentTypeFlags.TESTLETS:
          if (!isTestletDesign) isCompliant = false;
          break;
        case AuditAssesmentTypeFlags.PRESERVED_PARAMS:
          if (!hasPreservedParams) isCompliant = false;
          break;
        case AuditAssesmentTypeFlags.PT:
          if (!isPractice) isCompliant = false;
          break;
        case AuditAssesmentTypeFlags.IS_RESOURCE_ONLY:
          if (!isResourceOnly) isCompliant = false;
          break;
        default:
          // Handle unexpected required types if necessary
          break;
      }

      // Exit early if a requirement is not met
      if (!isCompliant) return false;
    }

    // An audit item is NOT compliant if it matches ANY of the excluded flags.
    for (const exclType of excludedFrameworkFlags) {
      switch (exclType) {
        case TestFormConstructionMethod.LINEAR:
          if (testFormType === TestFormConstructionMethod.LINEAR) isCompliant = false;
          break;
        case TestFormConstructionMethod.TLOFT:
          if (testFormType === TestFormConstructionMethod.TLOFT) isCompliant = false;
          break;
        case TestFormConstructionMethod.MSCAT:
          if (testFormType === TestFormConstructionMethod.MSCAT) isCompliant = false;
          break;
        case AuditAssesmentTypeFlags.QUESTIONNAIRE:
          if (isQuestionnaire) isCompliant = false;
          break;
        case AuditAssesmentTypeFlags.ALTERNATIVE:
          if (isAlternativeLinearTest) isCompliant = false;
          break;
        case AuditAssesmentTypeFlags.TESTLETS:
          if (isTestletDesign) isCompliant = false;
          break;
        case AuditAssesmentTypeFlags.PRESERVED_PARAMS:
          if (hasPreservedParams) isCompliant = false;
          break;
        case AuditAssesmentTypeFlags.PT:
          if (isPractice) isCompliant = false;
          break;
        case AuditAssesmentTypeFlags.IS_RESOURCE_ONLY:
          if (isResourceOnly) isCompliant = false;
          break;
        default:
          // Handle unexpected excluded types if necessary
          break;
      }

      // Exit early if an exclusion is matched
      if (!isCompliant) return false;
    }

    // If the code reaches this point, all requirements are met and no exclusions are matched.
    return isCompliant;
  }

  get frameworkDimensions() {
    const parameters = this.frameworkCtrl.getCurrentParameters().map(param => param.code);
    const historicalProps = this.itemBankCtrl.historicalPsychStatsSummary.historicalProps.map(prop => prop.slug);
    const psychStatsProps = this.itemBankCtrl.psychStatsProps;
    const allDimensions = [
      ...parameters,
      ...historicalProps,
      ...psychStatsProps
    ].filter(val => !isNullOrEmptyOrUndefined(val));
    return allDimensions
  }

  get AssesmentTypeId() {
    return this.itemMaker.assessmentParameters.find((assesment) => this.frameworkCtrl.asmtFmrk?.assessmentType == assesment.assessment_slug)?.id ?? -1;
  }

  excludedAuditsMapCache = new Map<number, ExcludedAuditsMap>();
  async getActiveAuditsByUserConfig(audits: IAuditConfig[]): Promise<IAuditConfig[]> {
    if (!this.itemMaker?.assessmentParameters?.length) {
      await this.itemMaker.initializeParameters();
    }

    let excludedAuditsMap: ExcludedAuditsMap = {};
    if (!this.excludedAuditsMapCache[+this.AssesmentTypeId]) {
      try {
        excludedAuditsMap = (await this.auth.apiGet(this.routes.TEST_AUTH_AUDIT_MANAGEMENT, this.AssesmentTypeId))?.config ?? {};
      } catch (error) {
        console.log(error.message);
      }
      this.excludedAuditsMapCache[+this.AssesmentTypeId] = JSON.parse(JSON.stringify(excludedAuditsMap));
    } else {
      excludedAuditsMap = JSON.parse(JSON.stringify(this.excludedAuditsMapCache[+this.AssesmentTypeId]));
    }

    const result: IAuditConfig[] = [];

    for (const audit of audits ?? []) {
      const auditSlug = audit.slug;
      const exclusion = excludedAuditsMap[auditSlug];
      const currentExclusion = this.getExcludedAudit(auditSlug);
    
      if (exclusion?.isExcluded) {
        currentExclusion.isExcluded = true;
        continue;

      }

      const sanitizedAudit: IAuditConfig = JSON.parse(JSON.stringify(audit));

      if (sanitizedAudit.checks?.length && exclusion?.excludedChecks) {
        sanitizedAudit.checks.forEach(check => {
          if (exclusion.excludedChecks[check.id]) {
            currentExclusion.excludedChecks[check.id] = true;
            check.isHidden = true;
          }
        });

        const filteredChecks = sanitizedAudit.checks.filter(check => !currentExclusion.excludedChecks[check.id]);

        if (filteredChecks.length) {
          sanitizedAudit.checks = filteredChecks;
          result.push(sanitizedAudit);
        }
      } else {
        result.push(sanitizedAudit);
      }
    }

    return result;
  }

  async getActiveAudits(includeHidden: boolean = false, auditConfigs: IAuditConfig[] = this.audits): Promise<IAuditConfig[]> {
    if (!includeHidden) {
      const originalAudits = JSON.parse(JSON.stringify(auditConfigs));
      const userFilteredAudits = await this.getActiveAuditsByUserConfig(originalAudits);
      return this.getActiveAuditsByFramework(userFilteredAudits);
    }

    return [...this.audits];
  }

  /**
   * Function to confirm if an audit check has required params to work with given a list of parameters
   * @param check audit check
   * @param activeParams params to check defaults to current frameworks active params
   * @returns 
   */
  checkFrameworkHasReqParams(check:TAuditCheck, commonCheckProps:Partial<TAuditCheck>, activeParams: string[] = this.frameworkDimensions ?? []):boolean{
    const commonTargetProp = commonCheckProps?.checkConfig && ('targetProp' in commonCheckProps.checkConfig) ?
      commonCheckProps.checkConfig.targetProp
      : ''
    if(check.requiredFrameworkParamCodes){
      for(let reqParam of check.requiredFrameworkParamCodes){
        if(!activeParams.includes(reqParam)){
          return false
        }
      }
    }
    switch (check.checkType ?? commonCheckProps?.checkType){
        case AuditCheckType.PROP_VAL:
        const checkPropVal = <ICheckPropVal>check.checkConfig;
        if(activeParams.includes(checkPropVal?.targetProp ?? commonTargetProp)){
          return true;
        } else return false;
        case AuditCheckType.PROPS_CONFIG: // all checks have to be true so if one check requires a param to be a value and it doesn't exist it should no longer 
        const checkPropConfigAnd = <ICheckProp[]>check.checkConfig;
        if (checkPropConfigAnd?.length && checkPropConfigAnd.every(config => activeParams.includes(config.targetProp ?? commonTargetProp))) {
          return true;
        } else return false;
        case AuditCheckType.PROPS_CONFIG_OR: // only one check to param is required to flag will still be valid if some of the params are missing
        const checkPropConfigOr = <ICheckProp[]>check.checkConfig;
        if (checkPropConfigOr?.length && checkPropConfigOr.some(config => activeParams.includes(config.targetProp ?? commonTargetProp))) {
          return true;
        } else return false;
        default:
          return true
      }
  }

  getProcessedCheck(_checks: TAuditCheck[], commonCheckProps: Partial<TAuditCheck>) {
    return _checks?.map(check => {
      const mergedCheck = _.merge({}, commonCheckProps, check);
      if(check.checkType === AuditCheckType.COMPOSITE){
        check.checkConfig = this.getProcessedCheck(<TAuditCheck[]>check.checkConfig,commonCheckProps )
      } else if (Array.isArray(mergedCheck.checkConfig)) {
        mergedCheck.checkConfig = mergedCheck.checkConfig.map(c =>
          _.merge({}, commonCheckProps?.checkConfig, c)
        );
      }

      return mergedCheck;
    }) || [];
  }

    
  async runCustomAudit(auditSlug:string, scope:AuditQuestionScope, isLangSensitive:boolean = true, auditTarget:AuditTarget, activeQuestion?:IQuestionConfig, bulkRun?: boolean){
    this.markAuditRunning(auditSlug, true);
    const isQuestionLevelAudit = !!activeQuestion && auditTarget === AuditTarget.QUESTIONS;
    const questionId = activeQuestion?.id;
    try{
      const auditResultsModel = await this.renderAuditResultsModel(auditSlug, activeQuestion? AuditQuestionScope.NONE : scope, isLangSensitive);
      if(isQuestionLevelAudit){
        const isActiveQuestionInScope = checkQuestionInScope(activeQuestion, scope, this.getContext());
        auditResultsModel.questions = isActiveQuestionInScope ? [(activeQuestion)] : [];
      }
      let skipResultsRollUp = false
      // console.log(auditSlug, typeof this.customIterators[auditSlug])
      if (typeof this.customIterators[auditSlug] === 'function') {
        const {isCustomResults} = await this.customIterators[auditSlug](auditResultsModel);
        skipResultsRollUp = isCustomResults
      }
      else if (!auditResultsModel.audit.isCompleteCheck) { // skip 
        this.alert('Audit is not configured for ' + auditSlug)
      }

      const commonCheckProps = auditResultsModel.audit.commonCheckProps || {};
      const checks: TAuditCheck[] = auditResultsModel.audit?.checks?.map(check => _.merge({}, commonCheckProps, check)) || []; // side effect, breaks symbolic link
      
      // Check if any checks require psych stats data
      const hasPsychStatsChecks = commonCheckProps.checkType === AuditCheckType.PROPS_CONFIG_PSYCH_STATS || checks.some(check => check.checkType === AuditCheckType.PROPS_CONFIG_PSYCH_STATS);
      let psychStatsData: Map<number, any> = new Map();
      
      if (hasPsychStatsChecks && auditResultsModel.questions.length > 0) {
        psychStatsData = this.fetchPsychStatsData(auditResultsModel.questions);
      }
      
      for (let check of checks){
        if (check.checkType){
          await processCheck(check, auditResultsModel.auditResultsMap, auditResultsModel.questions, {
            itemBankCtrl: this.itemBankCtrl,
            frameworkCtrl: this.frameworkCtrl,
            customCheckFunctions: this.customCheckFunctions
          }, psychStatsData)
        }
      }
      if (!skipResultsRollUp){
        const audit = this.audits.find(a => a.slug === auditSlug);
        const memId = this.getAuditResultSlug(activeQuestion?.id ?? this.itemBankCtrl.customTaskSetId, AuditResultType.OVERALL);
        if (!this.auditQuestionMem[memId]) {
          this.auditQuestionMem[memId] = {};
        }
        let __metaData: IAuditResultSummary;
        if (audit?.auditType && !this.auditQuestionMem[memId][audit.auditType]) {
          this.auditQuestionMem[memId][audit.auditType] = {pass: 0, fail: 0, informative: 0, lastRan: -Infinity, firstRan: Infinity};
        }
        if(!auditTypeWithoutSummary.has(audit.auditType)){
          __metaData = this.auditQuestionMem[memId][audit.auditType];
        }
        this.populateResultsInAuditItemMem(auditResultsModel.checkIds, auditSlug, auditResultsModel.auditResults, auditResultsModel.auditResultsMap, auditTarget, __metaData, !!activeQuestion, bulkRun);
        const results = this.getFormattedResults(auditResultsModel.checkIds, auditResultsModel.auditResultsMap, auditSlug);
        const isTestletOnly = false;
        const isRan = true;
        await this.markAuditAsRan(auditSlug, isTestletOnly, isRan, results, isQuestionLevelAudit ? questionId : null); 
        if(this.auditsWithError[auditSlug] = true){
          this.auditsWithError[auditSlug] = false
        }
      }
    } catch(e){
      if(!this.runningItemLevelAuditId){
        console.error(e); // so we don't log on the item level one as it crowd console
      }
      this.auditsWithError[auditSlug] = true
    }
    if(!bulkRun){
      this.checkFunctionCache = {};
    }
    this.markAuditRunning(auditSlug, false);
  }

  
  private getAuditBySlug(auditSlug:string) : IAuditConfig | null {
    // First check in our filtered list of audits
    for (let audit of this.audits) {
      if (audit.slug === auditSlug) {
        return audit;
      }
    }
    
    // If not found in filtered list, check in the original configs
    // This is useful for cases where a direct slug reference is needed even for hidden/excluded audits
    for (let audit of this.audits) {
      if (audit.slug === auditSlug) {
        return audit;
      }
    }
    
    return null;
  }

  getQuestionMemResults(slug: string| number, prefix:AuditResultType = AuditResultType.DEFAULT){
    return this.auditQuestionMem[this.getAuditResultSlug(slug, prefix)] ?? {};
  }

  auditResultCoreMap: Map<string, AuditResultCore> = new Map(); 
  private async renderAuditResultsModel(auditSlug:string, scope:AuditQuestionScope, isLangSensitive:boolean = true) : Promise<AuditResultCore> {
    const audit = JSON.parse(JSON.stringify(this.getAuditBySlug(auditSlug)));
    let checkIds = [];
    const auditResults:IAuditResult[] = [];
    if (audit && audit.checks){
      audit.checks = audit.checks.filter(check => !this.getExcludedAudit(auditSlug).excludedChecks[check.id])
      checkIds = audit.checks.map(check => check.id);
      const {excludedItems = [], informativeOnly} = audit.commonCheckProps ?? {};
      for (let check of audit.checks){
        try{
          auditResults.push({
            id: check.id, 
            caption: check.caption?.[this.lang.c()],
            typeCaption: check.typeCaption,
            type: check.checkElType || audit?.commonCheckProps?.checkElType || 'QUESTION',
            excludedItems: check?.excludedItems ?? excludedItems,
            informativeOnly: proccessInformativeOnly(check?.informativeOnly, informativeOnly, this.getContext()),
            items: [], 
            autoFixContext: []
          })
        } catch(e) {
          console.log(audit, e)
        }
      }
    }
    const questions = (await getQuestionsByScope(scope, this.getContext(), isLangSensitive)).filter(q => !!q);
    const auditResultsMap: Map<string, IAuditResult> = new Map();
    auditResults.forEach(result => auditResultsMap.set(result.id, result))
    const auditResultCore:AuditResultCore =  {
      audit, // should be read only, please
      auditSlug,
      checkIds,
      questions,
      auditResults, 
      auditResultsMap,
    }
    this.handleAuditTargetPanels(audit.auditTarget, auditResultCore);
    this.auditResultCoreMap.set(auditSlug, auditResultCore);
    return auditResultCore
  }

  private generateDynamicCheck(auditResultCore: AuditResultCore, check:TAuditCheck){
    const {audit, auditResultsMap, checkIds, auditResults} = auditResultCore;
    const {excludedItems = [], informativeOnly} = audit.commonCheckProps ?? {};
    const result = {
      id: check.id, 
      caption: check.caption[this.lang.c()],
      typeCaption: check.typeCaption,
      type: check.checkElType || audit?.commonCheckProps?.checkElType || 'QUESTION',
      excludedItems: check?.excludedItems ?? excludedItems,
      informativeOnly: proccessInformativeOnly(check?.informativeOnly, informativeOnly, this.getContext()),
      items: [], 
      autoFixContext: []
    };
    auditResults.push(result);
    checkIds.push(check.id);
    audit.checks?.push(check);
    auditResultsMap.set(check.id, result);
  }

  private handleAuditTargetPanels(
    auditTarget: AuditTarget,
    auditResultCore: AuditResultCore
  ) {
    switch (auditTarget) {
      case AuditTarget.MSCAT_PANELS:
        auditResultCore.mscatPanels = this.frameworkCtrl.asmtFmrk.panels.filter(panel => !panel.isDisabled);
        if (!auditResultCore.mscatPanels?.length && this.frameworkCtrl.asmtFmrk.testFormType === TestFormConstructionMethod.MSCAT) {
          this.alert("Please ensure there are panels to audit");
          throw new Error(AuditErrors.NO_PANELS_TO_AUDIT);
        }
        break;
      case AuditTarget.TLOFT_PANELS:
        auditResultCore.tloftPanels = this.frameworkCtrl.asmtFmrk.assembledPanels.filter(p => !p.isExcluded);
        if (!auditResultCore.tloftPanels?.length) {
          this.alert("Please ensure there are panels to audit");
          throw new Error(AuditErrors.NO_PANELS_TO_AUDIT);
        }
        break;
      case AuditTarget.PANELS:
        this.handleAuditTargetPanels(PANEL_AUDIT_TYPE_TO_TARGET_DICT[this.frameworkCtrl.asmtFmrk.testFormType], auditResultCore);
        break;
      case AuditTarget.LINEAR_SECTIONS:
        auditResultCore.linearSections = this.frameworkCtrl.asmtFmrk.partitions;
        break;
      case AuditTarget.QUESTIONS:
        break;
    }
  }

  private populateResultsInAuditItemMem(checkIds:string[], auditSlug, auditResults, auditResultsMap, auditTarget:AuditTarget, metaData:IAuditResultSummary, itemLevel: boolean = false, bulkRun: boolean = false) {
    let resultMetaPrev:IAuditResultSummary = JSON.parse(JSON.stringify(this.auditQuestionMem[this.getAuditResultSlug(auditSlug)]?.__metaData ?? {pass:0, fail:0, informative: 0}));
    this.auditQuestionMem[this.getAuditResultSlug(auditSlug)] = auditResults;
    let __metaData = <IAuditResultSummary>auditResults?.__metaData;
    if(resultMetaPrev && !(itemLevel || bulkRun) && metaData){ // remove previous result from overall metadata unless item level as all ran at once so info is cleared and set before
      metaData.pass -= resultMetaPrev.pass;
      metaData.fail -= resultMetaPrev.fail;
      metaData.informative -= resultMetaPrev.informative;
      metaData.lastRan = Date.now();
      if(!metaData.firstRan || metaData.firstRan === Infinity) metaData.firstRan = metaData.lastRan;
      const auditLog = this.getAuditLog(auditSlug);
      if(auditLog?.audited_on && metaData.firstRan >= (new Date(auditLog.audited_on).getTime() )){
        this.auditLogs.forEach(log =>{
          if(log.audit_slug !== auditSlug && log.auditType === auditLog.auditType){ // the previous log is still in the system so we want to ignore
            metaData.firstRan = Math.min(metaData.firstRan, new Date(log.audited_on).getTime())
          }
        })
      }
    }
    __metaData = { pass: 0, fail: 0, informative: 0 };
    if (checkIds?.length) {
      for (const checkId of checkIds) {
        if (!checkId) continue;
    
        let result = auditResultsMap.get(checkId);
        if (!result && auditResults) {
          result = auditResults.find(ar => ar.id === checkId);
          if (result) {
            auditResultsMap.set(checkId, result);
          }
        }
    
        if (!result || result.hidden){
          continue;
        }
    
        // Determine items based on audit target
        let items: any[] = [];
        switch (auditTarget) {
          case AuditTarget.PANELS:
          case AuditTarget.MSCAT_PANELS:
          case AuditTarget.TLOFT_PANELS:
          case AuditTarget.LINEAR_SECTIONS:
            items = result.items ?? [];
            break;
    
          case AuditTarget.QUESTIONS:
          default:
            if(checkId === 'ASSETS_W_OUTSTANDING_CMTS'){
              items = result.items
            } else {
              const filtered = applyItemFilter(result.items, result.excludedItems, this.getContext());
              items = filtered?.map(i => this.itemBankCtrl.getQuestionById(i?.id)) ?? [];
            }
            break;
        }
    
        // Save to auditQuestionMem
        this.auditQuestionMem[`${auditSlug}_${checkId}`] = items;
        this.auditQuestionMem[`${auditSlug}_${checkId}_AUTOFIX_CONTEXT`] = result.autoFixContext ?? [];
    
        // Update auditQuestionMem result cache
        const auditResultSlug = this.getAuditResultSlug(auditSlug);
        const auditQuestionMemResult = this.auditQuestionMem[auditResultSlug]?.find(subAudit => subAudit.id === checkId);
        if (auditQuestionMemResult) {
            auditQuestionMemResult.items = items.filter((v, i, a) => a.findIndex(v2 => v2?.id === v?.id) === i);
        }
    
        // Update __metaData
        let count = items?.length ?? 0;
        // If itemId is present, cap count at as were doing it at the item level
        if (itemLevel && count > 1) count = 1;
        if (!count) __metaData.pass++;
        else if (result.informativeOnly) __metaData.informative += count;
        else __metaData.fail += count;
      }
    
      // Store cumulative metadata
      if (metaData) {
        metaData.pass += __metaData.pass;
        metaData.fail += __metaData.fail;
        metaData.informative += __metaData.informative;
      }
    
      if (auditResults) {
        auditResults.__metaData = __metaData;
      }
    }
    
  }
  
  private getFormattedResults(checkIds:string[], auditResultsMap, auditSlug?:string) {
    const results: IAuditFormattedResult[] = [];
    
    for (let checkId of checkIds) {
      // Skip excluded checks
      if (!checkId || this.excludedAuditMap?.[auditSlug]?.excludedChecks[checkId]) continue;
      
      const result = auditResultsMap.get(checkId);
      const items = applyItemFilter(result.items, result.excludedItems, this.getContext());
      
      results.push({
        id: checkId,
        caption: result.caption,
        isAutoFixable: result.isAutoFixable || false,
        items: items,
        num_issues: result.informativeOnly ? 0 : result.items?.length ?? 0,
        informativeOnly: !!result.informativeOnly
      });
    }
    
    return results;
  }
  
  private async markAuditAsRan(auditSlug: string, isTestletsOnly: boolean, isRan: boolean= true, results?: any, activeQuestionId?:number) {
    if (isTestletsOnly) {
      this.auditsRan[auditSlug + '/TESTLETS'] = isRan;
    }
    
    // Only count non-hidden results in issues
    let num_issues = 0;
    results.forEach(result => {
      // Skip hidden results when counting issues
      if (!this.getExcludedAudit(auditSlug)?.excludedChecks[result.id ?? result.key]) {
        num_issues += result.num_issues ?? result.items?.length ?? 0;
      }
    });
    const audit = this.getAuditBySlug(auditSlug);
    const formattedResults:any = {
      item_set_id: this.itemBankCtrl.customTaskSetId, 
      audit_slug: auditSlug, 
      audit_results: JSON.stringify({results, __metaData: this.auditQuestionMem[this.getAuditResultSlug(auditSlug)]?.__metaData}),
      auditType: audit.auditType,
      lang: this.lang.c(),
      num_issues
    }
    // log
    if(activeQuestionId){
      formattedResults.item_id = activeQuestionId;
      }
    formattedResults.audited_on = Date.now();
    formattedResults.audited_by_uid = this.auth.getUid();
    formattedResults.email = this.auth.u().email;
    formattedResults.name = this.auth.getDisplayName();
    this.auditsRan[auditSlug] = isRan;
    await this.updateAudit(auditSlug, formattedResults);
  }

  async updateAudit(auditSlug:string, formattedResults:any){
    let auditIndex = this.auditLogs.findIndex(log => log.audit_slug == auditSlug);
    if(auditIndex === -1){
      auditIndex = this.auditLogs.length ?? 0;
    }
    this.auditLogs[auditIndex] = formattedResults;
    this.auditRanSub.next(auditSlug); // pass slug so we know which audit was completed
    await this.auth.apiCreate(this.routes.TEST_AUTH_ITEM_SET_AUDITS, formattedResults);
  }

  // resets the state to all listed audits so that they look "ready to run" as opposed to "already run"
  refreshAudit(auditSlugs:string[]) {
    if(auditSlugs.some(slug => this.activeAuditItemMemId?.includes(slug))){
      this.clearAuditPanels();
      this.clearAuditQuestions();
    }
    auditSlugs.forEach(slug => {
      if(this.auditQuestionMem.hasOwnProperty(slug)){
        delete this.auditQuestionMem[slug];
      }
      if(this.auditsRan.hasOwnProperty(slug)){
        delete this.auditsRan[slug];
      }
    });
  }
  
  // generalized autofix algorithm that runs in series for any process that requires it (this cannot function without a process fix)
  runQuestionAutoFixes(fixFlag:string, questionMems:string[], processFix:(question:IQuestionConfig)=>Promise<any> ) {
    return new Promise( (resolve, reject) => {
      this.auditQuestionMem[fixFlag] = {i:0, n:1};
      let questions:IQuestionConfig[] = [];
      questionMems.forEach(questionMemKey => {
        questions = questions.concat(this.auditQuestionMem[questionMemKey]);
      })
      this.auditQuestionMem[fixFlag].n = questions.length - 1 
      const questionLabels = [];
      questions.forEach(question => {
        if (questionLabels.indexOf(question?.label) === -1){
          questionLabels.push(question?.label);
        }
      })
      let currentQuestionIndex = 0;
      let currentQuestion;
      const fixNextQuestion = () => {
        this.auditQuestionMem[fixFlag].i = currentQuestionIndex
        if (currentQuestionIndex >= questionLabels.length){
          this.itemBankCtrl.selectQuestion(currentQuestion, true)
          this.auditQuestionMem[fixFlag] = false;
          this.alert('All questions have been fixed where possible. Please refresh the page in order to run another audit.');
          return;
        }
        const questionLabel = questionLabels[currentQuestionIndex];
        currentQuestion = this.itemBankCtrl.getQuestionByLabel(questionLabel);
        this.itemBankCtrl.selectQuestion(currentQuestion).then(()=>{
          currentQuestion = this.itemBankCtrl.getQuestionByLabel(questionLabel);
          processFix(currentQuestion).then(() => {
            currentQuestionIndex++;
            fixNextQuestion();
          })
        })
      }
      if (questionLabels.length > 0){
        fixNextQuestion()
      }
      else{
        this.auditQuestionMem[fixFlag] = false;
        resolve(undefined);
      }
    })
  }
      
  afterQuestionAutoFixes(){
    this.alert('There are no questions that can be auto-fixed.');
  }
          
  checkActiveQuestionMem(auditMemId: string) {
    if (this.activeAuditItemMemId === auditMemId) {
      return true;
    }
  }

    activateAuditQuestions(auditMemId: string) {
    this.auditItemListingMode = AuditTarget.QUESTIONS;
    this.activeAuditItemMemId = auditMemId;
    this.itemBankCtrl.currentItemListPage = 1;
    this.itemFilterCtrl.updateItemFilter();
    this.frameworkCtrl.scrollToQuestionListing();
  }
  
  clearAuditQuestions(){
    this.activateAuditQuestions(null);
  }

  
  activeAuditPanelIds: (number | string)[]; // panels being shown
  /**
   * Activate panel listing for failed MSCAT or TLOFT panels
   * @param auditMemId 
   * @param auditTarget 
   */
  activateAuditPanels(auditMemId: string, auditTarget?: AuditPanelTargets){
    this.auditItemListingMode = auditTarget;
    this.activeAuditItemMemId = auditMemId;
    this.activeAuditPanelIds = this.auditQuestionMem[auditMemId]?.map((panel) => panel.id);
  }

  /** Clear panel listing for failed audits */
  clearAuditPanels(){
    this.activateAuditPanels(null);
  }

  /** Clear item listing from audit results */
  clearAuditItemPreview(){
    this.clearAuditQuestions();
    this.clearAuditPanels();
  }
  
  // brought over from ABED
  initAuditAutoFixes(){

    this.customAutoFixes['CLONES_IS_AUTOFIXING'] = async (auditSlug:string, patchSlug:string) => {
      const cloneLinkParam = this.frameworkCtrl.identifySpecialParams(PARAM_SPECIAL_FLAGS.CLONE_LINKER)[0];
      this.runQuestionAutoFixes(
        'CLONES_IS_AUTOFIXING',
        [
          'CLONES_Q_CLONES_MISSING_PARAM',
          'CLONES_Q_CLONES_INVALID_PARAM',
        ],
        (questionFixing: IQuestionConfig) => {
          const question = questionFixing;
          const getCloneLabelCore = (label: string) => label.split('/')[0];
          const labelCore = getCloneLabelCore(question.label);
          question.meta[cloneLinkParam.code] = labelCore;
          return Promise.resolve();
        }
      )
      .then(() => this.afterQuestionAutoFixes() )
    }

    this.customAutoFixes['VOICEOVER_IS_AUTOFIXING'] = async (auditSlug:string, patchSlug:string) => {
      // const auditResultsMap = this.voiceoverAuditResults;
      enum LangId { EN = 'en', FR = 'fr' }
      enum CheckId { 'VOICEOVER_MISSING_OVERALL_VOICE', 'VOICEOVER_MISSING_OPTION_VOICE', 'VOICEOVER_CONTAIN_DUPLICATED_OPTION_VOICE' };
      const langId = this.lang.c();
      const renderAuditId = (checkId:CheckId) => CheckId[checkId];
      const busyFlag = patchSlug;

      Promise.all(
        [
          this.runQuestionAutoFixes("VOICEOVER_MISSING_OVERALL_VOICE_FIX", [renderAuditId(CheckId.VOICEOVER_MISSING_OVERALL_VOICE)], (questionFixing: IQuestionConfig) => {
            let question = this.lang.c() === 'en'? questionFixing : questionFixing.langLink;
            let script = this.scriptGen.autoGenQuestionVoiceover(question, langId, true);
            return this.scriptGen.uploadNewVoice(script, question.voiceover, langId)
          }),
          this.runQuestionAutoFixes("VOICEOVER_MISSING_OPTION_VOICE_FIX", [renderAuditId(CheckId.VOICEOVER_MISSING_OPTION_VOICE), renderAuditId(CheckId.VOICEOVER_CONTAIN_DUPLICATED_OPTION_VOICE)], (questionFixing: IQuestionConfig) => {
            let question = this.lang.c() === 'en'? questionFixing : questionFixing.langLink;
            console.log('fixing options', langId, questionFixing.label, question.voiceover);
            const entries = identifyQuestionResponseEntries(question.content, []);
            return Promise.all(
              entries.map(entry => {
                if (entry.elementType === ElementType.MCQ) {
                  const mcqEntry: IContentElementMcq = <any>entry;
                  if (mcqEntry.options) {
                    return Promise.all(
                      mcqEntry.options.map((option, option_index) => {
                        const scriptMeta: any = {
                          optionScripts: [],
                          useOldScripts: true,
                          useOldScriptsDecision: true,
                        }
                        return this.scriptGen.extractScriptFromMcqNodeAsync(mcqEntry, langId, scriptMeta, []);
                      })
                    )
                  }
                }
              })
            )
          })
        ]
      )
      .then(() => this.afterQuestionAutoFixes() )
    }

    this.customAutoFixes['EXPECTED_ANSWER_AUDIT_IS_AUTOFIXING'] = async(auditSlug:string, patchSlug:string) => {
      this.auditQuestionMem['EXPECTED_ANSWER_AUDIT_IS_AUTOFIXING'] = {n:0 , i:0}
      const auditsQuestionMemo = this.auditQuestionMem['EXPECTED_ANSWER_AUDIT_IS_AUTOFIXING'];
      const ranCode = 'EXPECTED_ANSWER_AUDIT';
      const singleMcqMissingSimulatedSub = ranCode + '_' + 'SINGLE_MCQ_MISSING_POSSIBLE_EXPECTED_ANSWER';
      const mcqMisMatchSimulatedSub = ranCode + '_' + 'Q_EXP_ANS_MISMATCH';
      
      const lang = this.lang.c();
      const questionsMissingExpectedAns: IQuestionConfig[] = this.auditQuestionMem[singleMcqMissingSimulatedSub];
      const questionsMismatchedExpectedAns: IQuestionConfig[] = this.auditQuestionMem[mcqMisMatchSimulatedSub];
      const missMatchedExpectedAns = this.auditQuestionMem[auditSlug+"_"+ 'Q_EXP_ANS_MISMATCH' + '_AUTOFIX_CONTEXT'] || [];
      const MCQ_OPTION_MAP = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
      auditsQuestionMemo.i = 0;
      auditsQuestionMemo.n = (questionsMissingExpectedAns?.length ?? 0 ) + (missMatchedExpectedAns?.length ?? 0);

      const failedAddingSimulatedSub = [];
      const successAddingSimulatedSubQs = new Set();
      const failedAddingCorrectSimulatedSubQs = new Set();
      const failedToRemoveMisConfigQs = new Set();
      const removedMisConfigQs = new Set();

      const getMcqEntryState = (): IEntryStateMcq => {
        return {
          type: 'mcq',
          isCorrect: false,
          isStarted: false,
          isFilled: false,
          isResponded: false,
          selections: [],
          alreadyScrambled: undefined,
          score:  0,
          weight: 0,
          scoring_type: ScoringTypes.AUTO, 
        }
      };

      const promises: Promise<any>[] = []
      
      
      for (const qConfig of questionsMissingExpectedAns) {
        const contents = this.getQuestionContent(qConfig, this.lang.c());
        const scorableContent = this.getQuestionContentEntryElements(contents, true);
        const el = (<IContentElementMcq>scorableContent[0]);
        
        const expectedAnswers = (await this.itemEditCtrl.findAllExpectedAnswer(+qConfig.id))?.filter(ea => ea.lang === lang) ;
        
        const expectedAnswersSet = new Set();
        expectedAnswers.forEach(ans => { expectedAnswersSet.add(ans.formatted_response.trim()) });
        
        let noSpecifiedResponse = true;
        const mcqOptions: IContentElementMcqOption[] = el.options;
        const weight = getElementWeight(el);
        mcqOptions?.forEach((option, i) => {
          const currentOptionAsAns = MCQ_OPTION_MAP[i];
          const isCorrect = option.isCorrect;
          if(isCorrect) noSpecifiedResponse = false;
          // add to formatted resp
          const entryState = getMcqEntryState();
          entryState.isFilled = true;
          entryState.isResponded = true;
          entryState.isStarted = true;
          entryState.isCorrect = isCorrect;
          entryState.score = isCorrect ? weight : 0;
          entryState.weight = weight
          entryState.selections = [{
              i,
              id: option.optionId,
              elementType: option.elementType,
              content: option.elementType === ElementType.IMAGE ?  option.url : option.content                 
          }]
  
          const response = { [el.entryId] : entryState }                
          const p = this.addFormattedAnswerToSimulatedSubmission(qConfig, JSON.stringify(response))
          .then((res) => successAddingSimulatedSubQs.add(+qConfig.id))                 
          .catch((e) => failedAddingSimulatedSub.push({label: qConfig.label , id: qConfig.id, option}))
          .finally(() => auditsQuestionMemo.i++);
          promises.push(p);
        });
        if(noSpecifiedResponse) failedAddingCorrectSimulatedSubQs.add(+qConfig.id);
        
      }

      // for (const context of missMatchedExpectedAns){
      //   const {item_id, formatted_response, lang = this.lang.c()} = context
      //   const p = this.auth.apiRemove(this.routes.ITEM_SET_EXPECTED_ANS, item_id, {query:{formatted_response, lang}})
      //     .then(() => removedMisConfigQs.add(+item_id))
      //     .catch(() => failedToRemoveMisConfigQs.add(+item_id))
      //     .finally(() => auditsQuestionMemo.i++);
      //       promises.push(p);
      // }
      
      await Promise.all(promises);

      this.auditQuestionMem[singleMcqMissingSimulatedSub] = questionsMissingExpectedAns?.filter((q) => !successAddingSimulatedSubQs.has(+q.id) && !failedAddingCorrectSimulatedSubQs.has(+q.id));
      this.auditQuestionMem[mcqMisMatchSimulatedSub] = questionsMismatchedExpectedAns?.filter((q) => failedToRemoveMisConfigQs.has(+q.id));
      let completionAlert = "Completed Running Autofix:"
      if(successAddingSimulatedSubQs.size){
        completionAlert += '\n - Succesfully added simulated responses';
      }
      if(failedAddingCorrectSimulatedSubQs.size){
        completionAlert += '\n - Fix no response entry audit so that correct missing simulated expected answer can be fixed';
      }
      if(failedAddingSimulatedSub.length){
        completionAlert += `\n - Unkown error generating response for following questions: ${failedAddingSimulatedSub.join(', ')}`;
      }
      if(removedMisConfigQs.size){
        completionAlert += `\n - Succesfully removed misconfigured responses`;
      }
      if(failedToRemoveMisConfigQs.size){
        completionAlert += `\n - Failed to removed misconfigured responses for following questions: ${Array.from(failedToRemoveMisConfigQs).join(', ')}`;
      }
      this.alert(completionAlert);
      this.auditQuestionMem['EXPECTED_ANSWER_AUDIT_IS_AUTOFIXING'] = null;
    }

    this.customAutoFixes['ALTERNATIVE_ITEM_ADIF_AUDIT_IS_AUTOFIXING'] = async(auditSlug:string, patchSlug:string) => {
      this.runQuestionAutoFixes('ALTERNATIVE_ITEM_ADIF_AUDIT_IS_AUTOFIXING', ['ALTERNATIVE_ITEM_ADIF_AUDIT_ITEMS_MISSING_ALT'], (question:IQuestionConfig) =>{
        question.meta.ALT = 1;
        return Promise.resolve();
      });
    }

    this.customAutoFixes['ASSOCIATED_READING_PASSAGE_AUDIT_IS_AUTOFIXING'] = async(auditSlug:string, patchSlug:string) => {
      this.runQuestionAutoFixes('ASSOCIATED_READING_PASSAGE_AUDIT_IS_AUTOFIXING', ['ASSOCIATED_READING_PASSAGE_AUDIT_MISSING_PASSAGEID_PARAMETER_SINGLE'], (question:IQuestionConfig) =>{
        const questionConfig = this.itemBankCtrl.getQuestionContent(question);
        const readSelections = questionConfig.readSelections;
        if(readSelections?.length){
          const associatedPassage = this.itemBankCtrl.getQuestionByLabel(readSelections[0]);
          if(associatedPassage){
            question.meta.passageID = associatedPassage.id;
          }
        }
        return Promise.resolve();
      });
    }
    this.customAutoFixes['IRT_AUDIT_IS_AUTOFIXING'] = async(auditSlug:string, patchSlug:string) => {
      this.runQuestionAutoFixes('IRT_AUDIT_IS_AUTOFIXING', ['IRT_AUDIT_MISCONFIGURED_EXPECTATION_PARAMS'], (question:IQuestionConfig) =>{
        const {NSE} = question.meta || {};
        const nseNoe = NSE.split('.')?.[0];
        const nseStrand = splitLettersNumbers(NSE).letters;
        question.meta.NOE = nseNoe;
        question.meta.Strand = nseStrand;
        return Promise.resolve();
      });
    }
  }

  private getQuestionContentEntryElements(elements: IContentElement[], isAutoScoreable:boolean) {
    return <IContentElement[]>identifyQuestionResponseEntries(elements, [], isAutoScoreable);
  }
  
  async addFormattedAnswerToSimulatedSubmission(qConfig: IQuestionConfig, response_raw:string) {
      
    const data = {
      response_raw,
      test_question_id: +qConfig.id,
      item_set_id: this.itemBankCtrl.customTaskSetId,
      lang: this.lang.c(),
      create_expected_response: true
    }

    return this.auth.apiCreate(this.routes.SIMULATE_EXTRACT_RESPONSE, data);      
  }

  trackQuestionIssues = (key: string, isFixable: boolean, questionList: IQuestionConfig[], description: string, issueCategories: any[], totalIssues: number) => {
    this.auditQuestionMem[key] = questionList;
    const numIssues = questionList?.length;
    this.auditQuestionMem['NUM_' + key] = numIssues;
    issueCategories.push({
      key,
      id: key,
      isFixable,
      description
    });
    totalIssues += numIssues;
  };

  checkFunctionCache:TCheckCache = {}
  customCheckFunctions:TCheckFunctionType = {
    [ECheckFunctionIds.UTIL_TESTLET]: async (questions: IQuestionConfig[]) => {
      const questionsInTestlet = this.frameworkCtrl.setOfQuestionsInTestlets;
      return questions.filter((q) => !questionsInTestlet.has(+q.id));
    },

    [ECheckFunctionIds.UTIL_QUAD]: async (questions: IQuestionConfig[]) => {
      let questionsInQuadrants = this.frameworkCtrl.setOfQuestionsInQuadrants;;
      return questions.filter((q) => !questionsInQuadrants.has(+q.id));
    },

    [ECheckFunctionIds.Q_LABEL_DUPE]: async (questions: IQuestionConfig[]) => {
      const duplicates: IQuestionConfig[] = [];
      const questionsSeen = new Map();
      const questionsFirst = new Map();
      for (const question of questions) {
        const label = question.label.trim();
        if (questionsSeen.has(label)) {
          duplicates.push(question);
          const previousQuestion = questionsFirst.get(label);
          if (previousQuestion) {
            duplicates.push(previousQuestion);
            questionsFirst.set(label, null); // clear the first question to avoid duplicates in the results
          }
        } else {
          questionsSeen.set(label, true);
          questionsFirst.set(label, question);
        }
      }
      return duplicates;
    },

    [ECheckFunctionIds.UNTRACKED_ENTRIES]: async (questions: IQuestionConfig[]) => {
      return questions.filter((q) =>{
        const content = this.getQuestionContent(q)
        const tracker = collectAndEnsureEntryIds(content);
        return tracker.nonIndicatedEntries.length > 0
      })
    },

    [ECheckFunctionIds.Q_CLONES_INVALID_PARAM]: async (questions: IQuestionConfig[]) => {
      const clonedQuestionsRef = await this.getCachedValue(ECheckCache.CLONED_QUESTION_REF);
      const cloneIndicParam = this.getCloneLinkerParam();
      return questions.filter(question => {
        const labelCore = getCloneLabelCore(question.label);
        if (clonedQuestionsRef.has(labelCore)) {
          if (question.meta[cloneIndicParam.code] && question.meta[cloneIndicParam.code] !== labelCore) {
            return true;
          }
        }
        return false
      })
    },

    [ECheckFunctionIds.Q_CLONES_MISSING_PARAM]: async (questions: IQuestionConfig[]) => {
      const clonedQuestionsRef = await this.getCachedValue(ECheckCache.CLONED_QUESTION_REF);
      const cloneIndicParam = this.getCloneLinkerParam()
      return questions.filter(question => {
        const labelCore = getCloneLabelCore(question.label);
        if (clonedQuestionsRef.has(labelCore)) {
          if (!question.meta[cloneIndicParam.code]) {
            return true;
          }
        }
        return false
      })
    },

    [ECheckFunctionIds.CONTAIN_DUPLICATED_OPTION_VOICE]: async (questions: IQuestionConfig[]) => {
      return questions.filter(question => {
        const entries = identifyQuestionResponseEntries(question.content, []);
        const voiceUploadMap = new Set<string>();
        for(let entry of entries){
          if (entry.elementType === ElementType.MCQ){
            const mcqEntry:IContentElementMcq = <any> entry;
            if (mcqEntry.options){
              for(let option of mcqEntry.options){
                if (option.voiceover && option.voiceover.url) {
                  if (voiceUploadMap.has(option.voiceover.url)) {
                    return true
                  }
                  voiceUploadMap.add(option.voiceover.url)
                }
              }
            }
          }
        }
        return false
      })      
    },

    [ECheckFunctionIds.MISSING_OPTION_VOICE]: async (questions: IQuestionConfig[]) => {
      return questions.filter(question => {
        const entries = identifyQuestionResponseEntries(question.content, []);
        for(let entry of entries){
          if (entry.elementType === ElementType.MCQ){
            const mcqEntry:IContentElementMcq = <any> entry;
            if (mcqEntry.options){
              for (let option of mcqEntry.options){
                if (!option.voiceover || !option.voiceover.url) {
                  return true
                }
              }
            }
          }
        }
        return false
      })
    },

    [ECheckFunctionIds.MISSING_OVERALL_VOICE]: async (questions: IQuestionConfig[]) => {
      return questions.filter(question => !question.voiceover || !question.voiceover.url)
    },

    [ECheckFunctionIds.CONTAINS_NOT_ALLOWED_RESPONSE_BLOCKS]: async (questions: IQuestionConfig[], params) =>{
      const {allowedRespondables} = params

      return questions.filter(question => {
        const respondableElements = getQuestionRespondableDeep(question);
        if(respondableElements.length && respondableElements?.some(element => !allowedRespondables.includes(element))){
          return true;
        }
        return false
      })
    },

    [ECheckFunctionIds.IMAGES_MISSING_ALT_TEXT]: async (questions: IQuestionConfig[]) => {
      return questions.filter(q =>{
        const qContent = this.getQuestionContent(q);
        for(let content of qContent){
          switch(content.elementType){
            case ElementType.IMAGE:
              const imageContent =  (<IContentElementImage>content.images.default.image);
              if(!imageContent.altText) return true;
              break;
          }
        }
        return false;
      })
    },

    [ECheckFunctionIds.ASSETS_W_OUTSTANDING_CMTS]: async (questions: IQuestionConfig[]) =>{
      const {unresolvedAssetIds} = await this.getCachedValue(ECheckCache.UNRESOLVED_COMMENTS, questions);
      return unresolvedAssetIds
    },

    [ECheckFunctionIds.QS_W_OUTSTANDING_CMTS]: async (questions: IQuestionConfig[]) =>{
      const {unresolvedQIds} = await this.getCachedValue(ECheckCache.UNRESOLVED_COMMENTS, questions);
      return questions.filter(q => unresolvedQIds.includes(q.id))
    },

    [ECheckFunctionIds.PUBLISHED_CONTENT_DIFF_AUDIT]: async (questions: IQuestionConfig[]) => {
      const test_design_ids = prompt("Enter comma seperated test design ids :");
      const ids = test_design_ids.toString().split(',').map(id => id.trim()).filter(id => id != null);
      // console.log(ids)
      if(!ids.length || ids.length < 2){
        this.alert('Please Enter valid test design id');
        throw new Error();
      }
      try {
        const data: any[] = await this.auth.apiFind(this.routes.TEST_DESIGN_QUESTION_VERSIONS, {query: {test_design_ids: ids}})
        const parsedData = legacyItemContentDiff(data, false, {itemBankCtrl: this.itemBankCtrl});
        const prefix = 'PUBLISHED_CONTENT_DIFF_AUDIT';
        this.auditQuestionMem[prefix] = parsedData;
        this.auditResultHeader[prefix] = `${prefix} - Test design ids: ${ids} `;
        return parsedData
      } catch (error) {
        console.error(error);
        throw error;
      }
    },

    [ECheckFunctionIds.CURRENT_CONTENT_DIFF_AUDIT]: async (questions: IQuestionConfig[]) => {
      const test_design_id = parseInt(prompt("Enter the test design id :"));
      if(!test_design_id){
        this.alert('Please Enter valid test design id');
        throw new Error();
      }
      try {
        const data: any[] = await this.auth.apiFind(this.routes.TEST_DESIGN_QUESTION_VERSIONS, {query: {test_design_ids: [test_design_id]}})
        const parsedData = itemContentDiff(data, true, {itemBankCtrl: this.itemBankCtrl});
        const prefix = 'CONTENT_DIFF_AUDIT';
        this.auditQuestionMem[prefix] = parsedData;
        this.auditResultHeader['CONTENT_DIFF_AUDIT'] = `${prefix} - Test design id: ${test_design_id} `;
        return parsedData
      } catch (error) {
        console.error(error);
        throw error;
      } 
    },

    [ECheckFunctionIds.FIELD_ITEMS_EXCLUDED_IN_TEST_DESIGNS]: async (questions: IQuestionConfig[]) => {
      const itemBankQuestions = (await getQuestionsByScope(AuditQuestionScope.ITEM_BANK, this.getContext())).filter(q => q?.meta.FT);
      const questionSet = new Set(questions.map(q => q.id))
      return itemBankQuestions.filter(q =>{
        if(!questionSet.has(q.id)){
          return true;
        }
        return false;
      });
    },

    [ECheckFunctionIds.FIELD_ITEMS_IN_FT_TESTLETS_IN_NON_FT_TESTLET]: async (questions: IQuestionConfig[]) => {
      if (this.frameworkCtrl.asmtFmrk.testFormType !== TestFormConstructionMethod.LINEAR) {
        const ftQuadrant = new Set();
        this.frameworkCtrl.asmtFmrk.quadrants.forEach(q => {
          if (q.constraints.some(c => (c.param === 'FT_Pool') || (c.param === 'FT' && c.val === '1'))) {
            ftQuadrant.add(q.id);
          }
        });
        const testlestlets = this.frameworkCtrl.asmtFmrk.testlets.filter(testlet => !testlet.isDisabled)
        const ftQuestions = new Set<number>();
        const nonFtQuestions = new Set<number>();
        testlestlets.forEach(testlet => {
          if (ftQuadrant.has(+testlet.quadrant)) {
            testlet.questions.forEach(q => ftQuestions.add(+q.id))
          } else {
            testlet.questions.forEach(q => nonFtQuestions.add(+q.id))
          }
        });
        const activeQuestionInFtTestlet = new Set<number>();
        nonFtQuestions.forEach(q => {
          if (ftQuestions.has(q)) {
            activeQuestionInFtTestlet.add(q);
          }
        });
        return questions.filter(q => {
          if (activeQuestionInFtTestlet.has(+q.id)) {
            return true;
          }
          return false
        });
      }
      return []
    },

    [ECheckFunctionIds.DRAG_DROP_MISSING_TARGETS_INSERTION]: async (questions: IQuestionConfig[]) => {
      return questions.filter(question =>{
        const blockElements = getQuestionRespondableDeep(question);
        for (let i = 0; i < blockElements.length; i++) {
          const element = blockElements[i];
        
          if (element.elementType === ElementType.INSERTION) {
            if (element?.['textBlocks']) {
              if (!element?.['textBlocks'].some(textblock => (textblock.element.elementType === ElementType.BLANK || textblock.element.elementType === ElementType.BLANK_DEPRECIATED))) {
                return true;
              }
            } else {
              return true;
            }
          }
        }
        return false;
      })
    },

    [ECheckFunctionIds.COMPARE_ELEMENT_PROPERTY_NUMERIC]: async (questions: IQuestionConfig[], params) => {
      const {comparisonMethod, pathToPropA, pathToPropB, targetBlock, arrayFilters, targetBlockFilters} = params;
      return questions.filter(question =>{
        let elements = getQuestionDeepElements(question).filter(el => el.elementType === targetBlock)
        if(targetBlockFilters){
          elements = filterArray(targetBlockFilters, elements)
        }
        for(let block of elements){
          const propA = _.get(block, pathToPropA);
          const propB = _.get(block, pathToPropB);
          let valA;
          if(Array.isArray(propA)){
            const filterConfigs = arrayFilters?.filter(filter => filter.configTarget === 'pathToPropA');
            valA = filterArray(filterConfigs, propA)?.length ?? 0;
          } else {
            valA = propA
          }
          let valB;
          if(Array.isArray(propB)){
            const filterConfigs = arrayFilters?.filter(filter => filter.configTarget === 'pathToPropB');
            valB = filterArray(filterConfigs, propB)?.length ?? 0;
          } else {
            valB = propB
          }
          if(checkPropCondVal(valA, EFilterMethods.IS_NAN) || checkPropCondVal(valB, EFilterMethods.IS_NAN)){
            continue;
          }
          if(checkPropCondVal(valA, comparisonMethod, valB)){
            return true;
          }
        }
        return false
      })
    },

    [ECheckFunctionIds.COMPARE_ELEMENT_PROPERTY_TO_VAL_NUMERIC]: async (questions: IQuestionConfig[], params) => {
      const {comparisonMethod, pathToPropA, val, targetBlock, arrayFilters, targetBlockFilters} = params;
      return questions.filter(question =>{
        let elements = getQuestionDeepElements(question).filter(el => el.elementType === targetBlock)
        if(targetBlockFilters){
          elements = filterArray(targetBlockFilters, elements)
        }
        for(let block of elements){
          const propA = _.get(block, pathToPropA);
          let valA;
          if(Array.isArray(propA)){
            valA = filterArray(arrayFilters, propA)?.length ?? 0;
          } else {
            valA = propA
          }
          if(checkPropCondVal(valA, EFilterMethods.IS_NAN) || checkPropCondVal(val, EFilterMethods.IS_NAN)){
            continue;
          }
          if(checkPropCondVal(valA, comparisonMethod, val)){
            return true;
          }
        }
        return false
      })
    },

    [ECheckFunctionIds.ELEMENT_COUNT]: async (questions: IQuestionConfig[], params) => {
      const {comparisonMethod = EFilterMethods.GREATER_THAN, targetBlocks, arrayFilters, val = 0} = params;
      return questions.filter(question =>{
        const blocks = getQuestionDeepElements(question).filter(el => targetBlocks.includes(el.elementType as ElementType))
        const blockCount = filterArray(arrayFilters, blocks)?.length ?? 0;
        return checkPropCondVal(blockCount, comparisonMethod, val);
      })
    },

    [ECheckFunctionIds.CONTAINS_DUAL_TEXT_INPUT]: async (questions: IQuestionConfig[]) => {
      const flaggedQuestions:IQuestionConfig[] = []
      const check:Partial<IAuditCheckByFunctions> = {
                        checkType: AuditCheckType.BY_FUNCTION,
                        checkConfig:{
                            functionId: ECheckFunctionIds.ELEMENT_COUNT,
                            functionParams:{
                                targetBlocks: [ElementType.INPUT],
                                comparisonMethod: EFilterMethods.GREATER_THAN,
                                val: 0,
                                arrayFilters: [
                                    {
                                        target: 'isDual',
                                        filterMethod: EFilterMethods.IS_TRUTHY
                                    },
                                    {
                                        target: 'format',
                                        filterMethod: EFilterMethods.EQUAL,
                                        val: InputFormat.TEXT
                                    }
                                ]
                            }
                        }
                    }
      await processCheckByFunction(check, questions, flaggedQuestions, {...this.getContext(), customCheckFunctions: this.customCheckFunctions})
      return flaggedQuestions
    },

    [ECheckFunctionIds.INCORRECTLY_MAPPED_SCAN_SLUG]: async (questions: IQuestionConfig[], params) => {
      const { sectionToValidSlugMap, sectionToValidSSlugMap, scanParam } = params;
      const testletByQuestionId = await this.getCachedValue(ECheckCache.TESTLETS_BY_QUESTION_ID);
      return questions.filter(qConfig => {
        const scanSlug = qConfig.meta?.[scanParam];
        const foundTestlets = testletByQuestionId.get(qConfig.id) || [];;
        let hasValidSlug = false;
        let hasValidSimilaritySlug = true;
        for (const foundTestlet of foundTestlets) {
          const section = +foundTestlet.section - 1;
          const validSlugs = sectionToValidSlugMap[section] || [];
          if (validSlugs.includes(scanSlug)) {
            hasValidSlug = true;
            // Check for Session D scan slug mapping based on similarity slug
            const validSSlugs = sectionToValidSSlugMap[scanSlug] || [];
            if (validSSlugs.length > 0 && (!foundTestlet.similaritySlug || !validSSlugs.includes(foundTestlet.similaritySlug))) {
              hasValidSimilaritySlug = false;
            }
          }
        }
        if (!hasValidSlug) {
          return true
        } else if (!hasValidSimilaritySlug) {
          return true
        }
        return false
      })
    },
    
    [ECheckFunctionIds.FRAMEWORK_CONFIG]: async (questions: IQuestionConfig[], params) => {
      const {target, val, filterMethod} = params;
      const frameWorkProperty = _.get(this.frameworkCtrl.asmtFmrk, target)
      return [checkPropCondVal(frameWorkProperty, filterMethod, val)]
    },

    [ECheckFunctionIds.RESPONDABLE_COUNT]: async (questions: IQuestionConfig[], params) => {
      const {comparisonMethod, excludedBlocks = [], arrayFilters, val} = params;
      return questions.filter(question =>{
        const blocks = getQuestionRespondableDeep(question).filter(el => !excludedBlocks.includes(el.elementType as ElementType))
        const blockCount = filterArray(arrayFilters, blocks)?.length ?? 0;
        return checkPropCondVal(blockCount, comparisonMethod, val);
      })
    },

    [ECheckFunctionIds.HAS_RESPONDABLE]: async (questions: IQuestionConfig[], params) => {
      const { inverse, excludeHumanScored } = params
      const flaggedQuestions:IQuestionConfig[] = []
      const check:Partial<IAuditCheckByFunctions> = {
                        checkType: AuditCheckType.BY_FUNCTION,
                        checkConfig:{
                            functionId: ECheckFunctionIds.RESPONDABLE_COUNT,
                            functionParams:{
                                comparisonMethod: inverse?  EFilterMethods.EQUAL : EFilterMethods.GREATER_THAN,
                                val: 0
                            }
                        }
      }
      if(excludeHumanScored){
        questions = questions.filter(q => !checkQuestionInScope(q, AuditQuestionScope.ITEMS_HUMAN_SCORED, this.getContext()))
      }
      await processCheckByFunction(check, questions, flaggedQuestions, {...this.getContext(), customCheckFunctions: this.customCheckFunctions})
      return flaggedQuestions
    },

    [ECheckFunctionIds.EXPECTED_ANSWER]: async (questions: IQuestionConfig[], params) =>{
      const expAnsMap = await this.getCachedValue(ECheckCache.EXPECTED_ANSWER);
      const {arrayFilters, langs = [this.lang.c()], count = 0, comparisonMethod = EFilterMethods.GREATER_THAN} = params;
      return questions.filter(question =>{
        const qId = question.id;
        const expAns: ExpectedAnswer[] = [];
        langs.forEach(lang =>{
          const langExpAns = expAnsMap.get(qId)?.get(lang);
          if(langExpAns){
            expAns.push(...langExpAns);
          }
        })
        return checkPropCondVal(filterArray(arrayFilters, expAns)?.length ?? 0, comparisonMethod, count)
      })
    },

    [ECheckFunctionIds.ITEMS_MISSING_PRESERVED_PARAMS]: async (questions: IQuestionConfig[]) => {
      const preservedMetaParams = this.frameworkCtrl.asmtFmrk.preservedMetaParams
      return questions.filter(q => {
        for(let param of preservedMetaParams){
          if(isNullOrEmptyOrUndefined(q?.meta?.[param])){
            return true
          }
        }
        return false
      })
    },

    [ECheckFunctionIds.INCORRECT_NUMBER_OF_MODULES]: async (_, params) =>{
      const {updateCaption, auditSlug, checkId} = params;
      const numberOfModules = this.frameworkCtrl.asmtFmrk.panelAssembly?.allModules?.length || 0;
      if(updateCaption && this.auditResultCoreMap.get(auditSlug)?.auditResultsMap.get(checkId)?.caption){
        this.auditResultCoreMap.get(auditSlug).auditResultsMap.get(checkId).caption += ` (${numberOfModules})`
      }
      return this.frameworkCtrl.asmtFmrk.panels.filter(panel =>{
        return panel?.modules?.length !== numberOfModules
      })
    },

    [ECheckFunctionIds.MISALIGNED_ITEM_COUNT_BETWEEN_MODULES]: async (_, params) =>{
      const {moduleIds, includeFT} = params;
      const itemMetaMap = await this.getCachedValue(ECheckCache.ITEM_META_MAP);
      const getNumItems = (module:IPanelModuleConfig): number =>{
        return module.__cached_itemIds?.filter(id => includeFT ? true : !itemMetaMap.get(+id)?.FT)?.length ?? 0;
      }
      return this.frameworkCtrl.asmtFmrk.panels.filter((panel) =>{
        const modules = panel.modules.filter(module => moduleIds.includes(+module.moduleId));
        if(modules.length < 1){
          this.alert(`Targeted modules (${moduleIds.join(',')}) not found`)
          return []
        }
        const itemCount = getNumItems(modules[0]);
        return modules.some(module => getNumItems(module) !== itemCount)
      })
    },

    [ECheckFunctionIds.MISALIGNED_META_SUM_BETWEEN_MODULES]: async (_, params) => {
      const { moduleIds, targetParam } = params;
      const itemMetaMap = await this.getCachedValue(ECheckCache.ITEM_META_MAP);

      const getMetaSum = (module: IPanelModuleConfig): number => {
        return module.__cached_itemIds?.reduce((a, b) => a + (checkPropCondVal(itemMetaMap.get(b)?.[targetParam], EFilterMethods.IS_NAN) ? 0 : +itemMetaMap.get(b)?.[targetParam]), 0);
      }
      return this.frameworkCtrl.asmtFmrk.panels.filter((panel) => {
        const modules = panel.modules.filter(module => moduleIds.includes(+module.moduleId));
        if (modules.length < 1) {
          this.alert(`Targeted modules (${moduleIds.join(',')}) not found`)
          return []
        }
        const metaSum = getMetaSum(modules[0]);
        return modules.some(module => getMetaSum(module) !== metaSum)
      })
    },

    [ECheckFunctionIds.INCORRECT_NUMBER_OF_OP_ITEMS_IN_MODULE]: async (_ , params) => {
      const {checkId, auditSlug} = params;
      const itemMetaMap = await this.getCachedValue(ECheckCache.ITEM_META_MAP);
      const auditResultCore = this.auditResultCoreMap.get(auditSlug)
      if(auditResultCore?.auditResultsMap.get(checkId)){
        const auditResultIndex = auditResultCore.auditResults.findIndex(result => result.id === checkId);
        const auditCheckIndex = auditResultCore.checkIds.findIndex(result => result === checkId);
        auditResultCore.checkIds.splice(auditCheckIndex, 1);
        auditResultCore.auditResults.splice(auditResultIndex, 1);
        auditResultCore.auditResultsMap.delete(checkId);
      }
      const modulesExpectedNumItemMap = new Map<number, number>();
      const getNumItems = (module:IPanelModuleConfig): number =>{
        return module.__cached_itemIds?.filter(id => !itemMetaMap.get(+id)?.FT)?.length ?? 0;
      }
      this.frameworkCtrl.asmtFmrk.panelAssembly?.allModules?.forEach(module =>{
        const moduleOpItem = (module.item_count ?? 0) - (module.num_ft ?? 0);
        modulesExpectedNumItemMap.set(+module.id, moduleOpItem)
        this.generateDynamicCheck(auditResultCore, {
          id: `${checkId}_${module.id}`,
          caption: {en: `Has incorrect number of OP items (${moduleOpItem}) in module ${module.id}`, fr: `Has incorrect number of OP items (${moduleOpItem}) in module ${module.id}`}
        })
      })
      this.frameworkCtrl.asmtFmrk.panels.forEach(panel =>{
        panel.modules.forEach(module => {
          const numItems = getNumItems(module);
          const expNumItems = modulesExpectedNumItemMap.get(+module.moduleId);
          if(numItems !== expNumItems){
            const result = auditResultCore.auditResultsMap.get(`${checkId}_${module.moduleId}`);
            if(result){
              result.items?.push(panel)
            }
          }
        })
      })
      return []
    },

    [ECheckFunctionIds.PANEL_NAME_INCLUDES]: async (_, params) => {
      const {includeDisabled, targetString} = params;
      let target: (IAssembledPanel | IPanelModulesConfig)[] = [];
      switch(this.frameworkCtrl.testFormConstructionMethod.value as TestFormConstructionMethod){
        case TestFormConstructionMethod.TLOFT:
          target = this.frameworkCtrl.asmtFmrk.assembledPanels?.filter(panel =>{
            if(!includeDisabled && panel.isExcluded){
              return false;
            }
            if(panel.id?.toString().toLowerCase().includes(targetString.toLowerCase())){
              return true
            }
            return false
          });
          break;
        case TestFormConstructionMethod.MSCAT:
          target = this.frameworkCtrl.asmtFmrk.panels?.filter(panel =>{
            if(!includeDisabled && panel.isDisabled){
              return false
            }
            if(panel.id?.toString().toLowerCase().includes(targetString.toLowerCase())){
              return true
            }
            return false
          })
          break;
        case TestFormConstructionMethod.BUCKETS:
        case TestFormConstructionMethod.LINEAR:
        default:
          this.alert('Form Construction Method not supported for check type')
          break;
      }
      return target
    },

    [ECheckFunctionIds.MISSING_LINEAR_SECTIONS]: async() => {
      return this.frameworkCtrl.asmtFmrk.partitions?.length ? [] : [{id:null}]
    },

    [ECheckFunctionIds.EMPTY_LINEAR_SECTIONS]: async() => {
      return this.frameworkCtrl.asmtFmrk.partitions.filter(section => {
        if(!this.frameworkCtrl.getSectionQuestionsLinear(this.frameworkCtrl.asmtFmrk, section)?.questions?.length){
          return true
        }
        return false
      })
    },

    [ECheckFunctionIds.COUNT_MULTI_SELECT_MCQ_WITH_POSSIBLE_MISSING_EA]: async(questions: IQuestionConfig[]) => {
      const expAnsMap = await this.getCachedValue(ECheckCache.EXPECTED_ANSWER);
      return questions.filter(question =>{
        const scorableContent = this.getQuestionContentEntryElements(question.content, false);
        const expectedAnswers = expAnsMap.get(question.id)?.get(this.lang.c());
        for(let content of scorableContent){
          if (content.elementType === ElementType.MCQ && (content as IContentElementMcq).isMultiSelect) {
            const qC = content as IContentElementMcq;
            const numSelected = +(qC.maxOptions || 1);
            const options = qC.options?.length || 0;
            const correct = qC.options?.filter(opt => opt.isCorrect).length || 0;
            if (possiblePartialCorrectMCQ(numSelected, options, correct) > (expectedAnswers?.length || 0)) {
              return true
            }
          }
        }
        return false;
      })
    },

    [ECheckFunctionIds.FORMATTED_RESPONSE_WITH_MULTIPLE_SCORES]: async(questions: IQuestionConfig[]) => {
      const expAnsMap = await this.getCachedValue(ECheckCache.EXPECTED_ANSWER);
      return questions.filter(question =>{
        const expectedAnswers = expAnsMap.get(question.id)?.get(this.lang.c()) ?? [];
        const seenFormattedResponseScores = new Map<string, Set<number>>();      
        for(let ans of expectedAnswers){
          if (seenFormattedResponseScores.has(ans.formatted_response)) {
            seenFormattedResponseScores.get(ans.formatted_response)!.add(+ans.score);
          } else {
            seenFormattedResponseScores.set(ans.formatted_response, new Set([+ans.score]));
          }
        }
        return [...seenFormattedResponseScores.values()]?.some(responseScore => responseScore.size > 1)
      })
    },

    [ECheckFunctionIds.Q_EXP_ANS_LANG_MISMATCH]: async(questions: IQuestionConfig[]) => {
      const expAnsMap = await this.getCachedValue(ECheckCache.EXPECTED_ANSWER);
      const supportedLangs = this.itemBankCtrl.getSupportedLangs();

      if (supportedLangs.length < 2) {
        return [];
      }

      return questions.filter(question => {

        const langMap = expAnsMap.get(+question.id);

        if (!langMap) return false;
        const seenResponses = new Map<string, { score: number, weight: number }>();
        for (const langKey of supportedLangs) {
          const answers = langMap.get(langKey);
          if (!answers) continue;

          for (const ans of answers) {
            const existing = seenResponses.get(ans.formatted_response);

            if (existing) {
              if (existing.score !== ans.score || existing.weight !== ans.weight) {
                return true;
              }
            } else {
              seenResponses.set(ans.formatted_response, {
                score: ans.score,
                weight: ans.weight
              });
            }
          }
        }
        return false;
      });
    },

    [ECheckFunctionIds.Q_PARAM_MISMATCH]: async (questions: IQuestionConfig[], params) => {
      const { compositeParam, componentParam, indexStart } = params;

      return questions.filter(question => {
        const { meta } = question;

        const compositeRaw = meta?.[compositeParam];
        const componentRaw = meta?.[componentParam];

        const hasComposite = compositeRaw != null;
        const hasComponent = componentRaw != null;

        if (hasComposite !== hasComponent) {
          return true;
        }

        if (!hasComposite && !hasComponent) {
          return false;
        }

        const compositeStr = String(compositeRaw);
        const componentStr = String(componentRaw);

        const indexEnd = indexStart + componentStr.length;
        const extractedCompositeVal = compositeStr.slice(indexStart, indexEnd);

        return componentStr.toLowerCase() !== extractedCompositeVal.toLowerCase();
      });
    },

    [ECheckFunctionIds.SCORE_CATEGORIES_MISCONFIGURED_KEYS]: async (questions: IQuestionConfig[]) => {
      const scoreCatMap = await this.getCachedValue(ECheckCache.SCORE_CATEGORIES);
      return questions.filter(question =>{
        const scoreCatScaleMap = scoreCatMap.get(question.id);
        const seenPrimaryKeys = new Set<string>();
        if(scoreCatScaleMap){
          for(let key of Array.from(scoreCatScaleMap?.keys())){
            const scoreCategories = scoreCatScaleMap?.get(key) ?? [];
            for(let sc of scoreCategories){
              const scKey = `${sc.question_id}${sc.score}`;
              if(seenPrimaryKeys.has(scKey) || checkPropCondVal(sc.question_id, EFilterMethods.IS_NULL) || checkPropCondVal(sc.question_id, EFilterMethods.IS_NULL) || checkPropCondVal(sc.question_id, EFilterMethods.IS_NULL)){
                return true
              } else {
                seenPrimaryKeys.add(scKey)
              }
            }
          }
        } else {
          return false
        }
      })
    },

    [ECheckFunctionIds.SCORE_CATEGORIES_MISSING]: async (questions: IQuestionConfig[]) => {
      const scoreCatMap = await this.getCachedValue(ECheckCache.SCORE_CATEGORIES);
      return questions.filter(question => {
        const scoreCatScaleMap = scoreCatMap.get(question.id);
        if(!Array.from(scoreCatScaleMap?.keys() ?? []).length){
          return true;
        } else {
          return false;
        }
      })
    },

    [ECheckFunctionIds.ABS_DIFFERENCE_BETWEEN_SCORE_GREATER_THAN_TWO]: async (questions: IQuestionConfig[]) => {
      const scoreCatMap = await this.getCachedValue(ECheckCache.SCORE_CATEGORIES);
      return questions.filter(question =>{
        const scoreCatScaleMap = scoreCatMap.get(question.id);
        if(scoreCatScaleMap){
          for(let key of Array.from(scoreCatScaleMap?.keys() ?? [])){
            const scoreCategories = scoreCatScaleMap?.get(key) ?? [];
            for(let sc of scoreCategories){
              if(Math.abs(sc.score - sc.scoreCategory) > 2){
                return true
              }
            }
          }
        }
        return false;
      })
    },

    [ECheckFunctionIds.NUMBER_OF_SCORE_CATEGORY_MATCHES_THRESHHOLD_PARAM]: async (questions: IQuestionConfig[]) => {
      const scoreCatMap = await this.getCachedValue(ECheckCache.SCORE_CATEGORIES);
      const psychStatsData = this.fetchPsychStatsData(questions);
      return questions.filter(question =>{
        const scoreCatScaleMap = scoreCatMap.get(question.id);
        const qPsychStats = psychStatsData.get(question.id);
        if (Array.isArray(qPsychStats) && qPsychStats.length > 0) {
          for(let stat of qPsychStats){
             const uniqueScores = scoreCatScaleMap?.get(stat.scale_code);
             let thresholdParamCount = 0;
             for(let threshParam of psychThresholdParams){
              if(stat[threshParam] !== null){
                thresholdParamCount++;
              }
             }
             if(thresholdParamCount !== uniqueScores?.length){
              return true
             }
          }
        }
        return false;
      })
    },

    [ECheckFunctionIds.SCORE_CATEGORY_SEQUENTIAL_NO_MISSING_INTERMEDIATE]: async (questions: IQuestionConfig[]) => {
      const scoreCatMap = await this.getCachedValue(ECheckCache.SCORE_CATEGORIES);
      return questions.filter(question =>{
        const scoreCatScaleMap = scoreCatMap.get(question.id);
        if(scoreCatScaleMap){
          for (let scaleCode of Array.from(scoreCatScaleMap?.keys())) {
            const scoreCategories = scoreCatScaleMap?.get(scaleCode) ?? [];
            let prevScore = null;
            for (let sc of scoreCategories.sort((a, b) => a.scoreCategory - b.scoreCategory).sort((a, b) => a.score - b.score)) {
              if (prevScore !== null) {
                if (Math.abs(prevScore - sc.score) > 1) {
                  return true
                }
              }
              prevScore = sc.score;
            }
          }
        }
        return false;
      })
    },

    [ECheckFunctionIds.EXPS_ANS_SCORE_MISSING_FROM_SCORE_CAT]: async (questions: IQuestionConfig[]) => {
      const scoreCatMap = await this.getCachedValue(ECheckCache.SCORE_CATEGORIES);
      const expAnsMap = await this.getCachedValue(ECheckCache.EXPECTED_ANSWER);
      return questions.filter(question =>{
        const scoreCatScaleMap = scoreCatMap.get(question.id);
        const expAns: ExpectedAnswer[]  = expAnsMap[question.id]?.[this.lang.c()] ?? [];
        const expAnsScores = expAns.map(ans => ans.score);
        if(scoreCatScaleMap){
          for (let scaleCode of Array.from(scoreCatScaleMap?.keys() ?? [])) {
            const scoreCategories = scoreCatScaleMap?.get(scaleCode) ?? [];
            const scoreCatScores = new Set(scoreCategories.map(sc => sc.score));
            for(let score of expAnsScores){
              if(!scoreCatScores.has(score)){
                return true;
              }
            }
          }
        }
        return false;
      })
    },

    [ECheckFunctionIds.COMPARE_WEIGHT_TO_PARAM]: async (questions: IQuestionConfig[], params) => {
      const {param, comparisonMethod} = params;
      return questions.filter(question => {
        const paramWeight = question.meta?.[param];
        const qContent = this.getQuestionContent(question);
        const totalWeight = getQuestionPoints(qContent);
        return checkPropCondVal(paramWeight, comparisonMethod, totalWeight)
      })
    },

    [ECheckFunctionIds.COMPARE_EA_WEIGHT_TO_PARAM]: async (questions: IQuestionConfig[], params) => {
      const {param, comparisonMethod, expectedAnsTarget, aggregate} = params;
      const expAnsMap = await this.getCachedValue(ECheckCache.EXPECTED_ANSWER);
      return questions.filter(question => {
        const expAns = expAnsMap.get(+question.id)?.get(this.lang.c()) ?? [];
        const paramVal = question.meta?.[param];
        const expAnsTargets = expAns.map(ans => ans[expectedAnsTarget]);
        let val;
        switch(aggregate){
          case 'min':
            val = Math.min(...expAnsTargets);
            break;
          case 'max':
            val = Math.max(...expAnsTargets);
            break
        }
        return checkPropCondVal(paramVal, comparisonMethod, val);
      })
    },

    [ECheckFunctionIds.MISALIGNED_READING_PASSAGE]: async (questions: IQuestionConfig[], params) => {
      return questions.filter(question => {
        const questionPassagePrefix = question.label?.trim()?.split('_')?.[0];
        const readSelections = question.readSelections ?? [];
        for(let readSel of readSelections){
            if(readSel && readSel.trim()?.split('/')?.[0] !== questionPassagePrefix){
              return true
            } 
        }
        return false
      })
    },

    [ECheckFunctionIds.INVALID_READING_PASSAGE]: async (questions: IQuestionConfig[], params) => {
      const {excludeTrailing, onlyTrailing} = params;
      const existingBookmarksMap = await this.getCachedValue(ECheckCache.EXISTING_BOOKMARKS_MAP)
      return questions.filter(question => {
        const readSelections = question.readSelections ?? [];
        for (let readSel of readSelections) {
          if (!existingBookmarksMap.has(readSel)) {

            const existWithTrailing = existingBookmarksMap.has(readSel.trim());
            // --- CASE A: It exists, but only if trimmed (Trailing Error) ---
            if (existWithTrailing) {
              if (excludeTrailing) {
                continue; // User said ignore trailing errors -> Valid
              }
              return true;
            }

            // --- CASE B: It does not exist at all (Invalid Error) ---
            if (!existWithTrailing) {
              // If user ONLY wants trailing errors, we must IGNORE this "totally invalid" error
              if (onlyTrailing) {
                continue;
              }
              return true;
            }
          }
        }
        return false;
      })
    },

    [ECheckFunctionIds.INVALID_BOOKMARK_TARGET]: async (questions: IQuestionConfig[], params) => {
      const {excludeTrailing, onlyTrailing} = params;
      return questions.filter(question => {
        const readSelections = question.readSelections ?? [];
        const elements = getQuestionDeepElements(question);
        for (let e of elements) {
          if (e.elementType === ElementType.TEXT && e.paragraphStyle === TextParagraphStyle.ADVANCED_INLINE) {
            for (let textElement of e.advancedList) {
              if (textElement.elementType === ElementType.BOOKMARK_LINK) {
                const targetItem = textElement.itemLabel;
                const targetItemTrimmed = targetItem?.trim();
                if (targetItem && !readSelections.includes(targetItem)) {
                  const existWithTrailing = readSelections.includes(targetItemTrimmed);
                  // --- CASE A: It exists, but only if trimmed (Trailing Error) ---
                  if (existWithTrailing) {
                    if (excludeTrailing) {
                      continue; // User said ignore trailing errors -> Valid
                    }
                    return true;
                  }

                  // --- CASE B: It does not exist at all (Invalid Error) ---
                  if (!existWithTrailing) {
                    // If user ONLY wants trailing errors, we must IGNORE this "totally invalid" error
                    if (onlyTrailing) {
                      continue;
                    }
                    return true;
                  }
                }
              }
            }
          }
        }
        return false;
      })
    },

    [ECheckFunctionIds.INVALID_BOOKMARK_ID]: async (questions: IQuestionConfig[]) => {
      const existingBookmarksMap = await this.getCachedValue(ECheckCache.EXISTING_BOOKMARKS_MAP)
      return questions.filter(question => {
        const elements = getQuestionDeepElements(question);
        for (let e of elements) {
          if (e.elementType === ElementType.TEXT && e.paragraphStyle === TextParagraphStyle.ADVANCED_INLINE) {
            for (let textElement of e.advancedList) {
              if (textElement.elementType === ElementType.BOOKMARK_LINK) {
                const targetItem = textElement.itemLabel;
                const bookmarkId = textElement.bookmarkId;
                const targetItemTrimmed = targetItem?.trim();
                if (targetItemTrimmed && existingBookmarksMap.has(targetItemTrimmed) && !existingBookmarksMap.get(targetItemTrimmed)?.includes(bookmarkId)) {
                  return true
                }
              }
            }
          }
        }
        return false
      })
    },

    [ECheckFunctionIds.Q_PARAM_LINKS_TO_MISSING_QUESTION]: async (questions: IQuestionConfig[], params) => {
      const {param} = params;
      return questions.filter(question => {
        const linkedQuestionID = question.meta?.[param];
        return !!this.itemBankCtrl.getQuestionById(linkedQuestionID);
      })
    },

    [ECheckFunctionIds.Q_PSYCH_STATS_MISALIGNED_BETWEEN_LINKED_QUESTIONS]: async (questions: IQuestionConfig[], params) => {
      const { param } = params
      const psychStatMap = this.fetchPsychStatsData(questions);
      // 1. Fetch all async data in parallel first
      const results = await Promise.all(questions.map(async (question) => {
        let regPsychData = null;
        const altPsychData = psychStatMap.get(question.id);

        // Fetch data if param exists
        if (question?.meta?.[param]) {
          try {
            regPsychData = await this.frameworkCtrl.auth.apiGet(
              this.itemBankCtrl.routes.DATA_EXPORTER_PSYCH_ITEM_STATS,
              question.meta[param]
            );
          } catch (e) {
            regPsychData = null;
          }
        }

        // 2. Perform the Comparison Logic immediately (while we have scope)

        // Case A: Both exist - Compare them
        if (Array.isArray(regPsychData) && Array.isArray(altPsychData)) {
          if (regPsychData.length !== altPsychData.length) return true;

          const sanitizedReg = sanitizePsychStats(regPsychData);
          const sanitizedAlt = sanitizePsychStats(altPsychData);

          for (let i = 0; i < sanitizedAlt.length; i++) {
            const regObj = sanitizedReg[i];
            const altObj = sanitizedAlt[i];

            for (const key of psychStatDataCol) {
              if (regObj[key] != altObj[key]) return true;
            }
          }
          return false;
        }

        // Case B: Only Alt exists (Reg missing) -> Mismatch
        else if (altPsychData) {
          return true;
        }

        // Case C: Neither exists or only Reg exists (adjust based on your needs)
        return false;
      }));

      return questions.filter((_, index) => results[index]);
    },

    [ECheckFunctionIds.CORRECT_NUMBER_OF_OP_ITEMS]: async (_, params) => {
      const { checkId, auditSlug } = params;
      const auditResultsMap = this.auditResultCoreMap.get(auditSlug).auditResultsMap;
      let numOfOpItemsReq ;
      if (auditResultsMap.has(checkId)) {
        const numOfOpItemsReqRaw = prompt("How many Operational items are required per panel?");
        if (checkPropCondVal(numOfOpItemsReqRaw, EFilterMethods.IS_NAN)) {
          this.alert("Please ensure you're inputing a number and try again.")
          throw new Error(AuditErrors.INVALID_USER_INPUT)
        }
        numOfOpItemsReq = +numOfOpItemsReqRaw
        auditResultsMap.get(checkId).caption += ` (${numOfOpItemsReq})`
      }
      switch (this.frameworkCtrl.asmtFmrk.testFormType) {
        case TestFormConstructionMethod.LINEAR:
          let numOfOpItems = 0
          const flaggedSections = this.frameworkCtrl.asmtFmrk.partitions.filter(section => {
            const sectionQuestions = this.frameworkCtrl.getSectionQuestionsLinearConfig(section) || [];
            numOfOpItems += this.countOperationalItems(sectionQuestions, true);
          });
          if (numOfOpItemsReq && numOfOpItems !== numOfOpItemsReq) {
            return [{}]
          }
          return [];
        case TestFormConstructionMethod.TLOFT:
          return this.frameworkCtrl.asmtFmrk.assembledPanels.filter(assembledPanel => {
            const panelQuestions = this.frameworkCtrl.panelCtrl.getAssembledPanelQuestions(assembledPanel.id, false) || [];
            const numOfOpItems = this.countOperationalItems(panelQuestions, true);
            if (numOfOpItems !== numOfOpItemsReq) {
              auditResultsMap.get(checkId)?.items?.push(assembledPanel);
            }
          })
          break;
        case TestFormConstructionMethod.MSCAT:
          return this.frameworkCtrl.asmtFmrk.panels.filter(modulePanel => {
            const panelQuestions = this.frameworkCtrl.panelCtrl.getPanelQuestions(modulePanel.id) || [];
            const numOfOpItems = this.countOperationalItems(panelQuestions, true);
            if (numOfOpItems !== numOfOpItemsReq) {
              return true
            }
          })
      }
    },

    [ECheckFunctionIds.PANEL_HAS_REPEATED_QUESTION]: async (_) => {
      switch (this.frameworkCtrl.asmtFmrk.testFormType) {
        case TestFormConstructionMethod.LINEAR:
          const allQuestions: IQuestionConfig[] = [];
          this.frameworkCtrl.asmtFmrk.partitions.forEach(section => {
            const sectionQuestions = this.frameworkCtrl.getSectionQuestionsLinearConfig(section) || [];
            allQuestions.push(...sectionQuestions);
          });
          if (this.getDuplicatesByKey(allQuestions, 'id')?.length) {
            return [{}]
          }
          return [];
        case TestFormConstructionMethod.TLOFT:
          return this.frameworkCtrl.asmtFmrk.assembledPanels.filter(assembledPanel => {
            const panelQuestions = this.frameworkCtrl.panelCtrl.getAssembledPanelQuestions(assembledPanel.id, false) || [];
            if (this.getDuplicatesByKey(panelQuestions, 'id')?.length) {
              return true
            }
            return false
          })
        case TestFormConstructionMethod.MSCAT:
          const panels = this.frameworkCtrl.asmtFmrk.panels;
          const panelAssembly = this.frameworkCtrl.asmtFmrk.panelAssembly;
          const modulesByStage = new Map();
          const stageByModule = new Map();
          for (let module of panelAssembly.allModules) {
            const { stageNumber } = module;
            if (!modulesByStage.get(+stageNumber)) {
              modulesByStage.set(+stageNumber, []);
            }
            modulesByStage.get(+stageNumber).push(module.id);
            stageByModule.set(+module.id, stageNumber)
          }
          return panels.filter(panel => {
            for (let module of panel.modules) {
              const { moduleId, __cached_itemIds } = module;
              const itemIds = __cached_itemIds;
              // check duplicates within the same module
              const seenInModule = new Set<number>();
              for (const itemId of itemIds || []) {
                if (seenInModule.has(+itemId)) {
                  return true;
                }
                seenInModule.add(+itemId);
              }
            }
            return false;
          })
      }
    },

    [ECheckFunctionIds.PANEL_HAS_INCORRECT_NUM_SECTION]: async (_, params) => {
      const {auditSlug, checkId} = params;
      const auditResultsMap = this.auditResultCoreMap.get(auditSlug).auditResultsMap;
      let numOfSectionsReq;
      if(auditResultsMap.get(checkId)){
        numOfSectionsReq = +prompt(`How many ${this.frameworkCtrl.asmtFmrk.testFormType === TestFormConstructionMethod.MSCAT ? 'stages' : 'sections'} are required per panel?`);
        if(checkPropCondVal(numOfSectionsReq, EFilterMethods.IS_NAN)){
          this.alert("Please ensure you're inputing a number and try again.")
          throw new Error(AuditErrors.INVALID_USER_INPUT)
        }
        auditResultsMap.get(checkId).caption += ` (${numOfSectionsReq})`;
      }
      switch (this.frameworkCtrl.asmtFmrk.testFormType) {
        case TestFormConstructionMethod.LINEAR:
          this.frameworkCtrl.asmtFmrk.partitions.length !== numOfSectionsReq
          if (this.frameworkCtrl.asmtFmrk.partitions.length !== numOfSectionsReq) {
            return [{}]
          }
          return [];
        case TestFormConstructionMethod.TLOFT:
          return this.frameworkCtrl.asmtFmrk.assembledPanels.filter(assembledPanel => {
             const seenSections = new Set()
            assembledPanel.testletIds?.forEach(testletId => {
              const testlet = this.frameworkCtrl.testletCtrl.getTestletById(testletId);
              seenSections.add(+testlet.section);
            })
            if(seenSections.size !== numOfSectionsReq){
              return true
            }
            return false
          })
        case TestFormConstructionMethod.MSCAT:
          const panels = this.frameworkCtrl.asmtFmrk.panels;
          const panelAssembly = this.frameworkCtrl.asmtFmrk.panelAssembly;
                    const stageByModule = new Map();
          for (let module of panelAssembly.allModules){
            const {stageNumber} = module;
            stageByModule.set(+module.id, stageNumber)
          }
          return panels.filter(panel => {
            const uniqueStages = new Set<number>();
            for (let module of panel.modules) {
              const stageNumber = stageByModule.get(+module.moduleId);
              uniqueStages.add(+stageNumber)
            }
            if(uniqueStages.size !== numOfSectionsReq){
              return true
            }
            return false;
          })
      }
    },

    [ECheckFunctionIds.INCORRECT_NUM_OF_UNIQUE_PANELS]: async (_, params) => {
      const {auditSlug, checkId} = params;
      const auditResultsMap = this.auditResultCoreMap.get(auditSlug).auditResultsMap;
      let numOfUniquePanelsRequired;
      if(this.frameworkCtrl.asmtFmrk.testFormType !== TestFormConstructionMethod.LINEAR && auditResultsMap.get(checkId)){
        numOfUniquePanelsRequired = +prompt("How many unique panels are required?");
        if(checkPropCondVal(numOfUniquePanelsRequired, EFilterMethods.IS_NAN)){
          this.alert("Please ensure you're inputing a number and try again.")
          throw new Error(AuditErrors.INVALID_USER_INPUT)
        }
        auditResultsMap.get(checkId).caption += ` (${numOfUniquePanelsRequired})`;
      }
      switch (this.frameworkCtrl.asmtFmrk.testFormType) {
        case TestFormConstructionMethod.TLOFT:
          return this.frameworkCtrl.asmtFmrk.assembledPanels === numOfUniquePanelsRequired ? [] : this.frameworkCtrl.asmtFmrk.assembledPanels
        case TestFormConstructionMethod.MSCAT:
          return this.frameworkCtrl.asmtFmrk.panels.length === numOfUniquePanelsRequired ? [] : this.frameworkCtrl.asmtFmrk.panels
      }
    },

    [ECheckFunctionIds.SCORING_CONFIG]: async (questions: IQuestionConfig[], params) => {
      const { arrayFilters, comparisonMethod, target, count } = params
      return questions.filter(question => {
        const scoringInfo = this.itemBankCtrl.getQuestionScoringInfo(question.id);
        let targetValue = _.get(scoringInfo, target);
        if (target === 'scales' && typeof targetValue === 'string') {
          try {
            targetValue = JSON.parse(targetValue)
          } catch {
            targetValue = []
          }
        }
        if (Array.isArray(targetValue)) {
          targetValue = filterArray(arrayFilters, targetValue).length;
        }
        return checkPropCondVal(targetValue, comparisonMethod, count)
      })
    },

    [ECheckFunctionIds.MISCONFIGURED_SCORING_SCALE]: async (questions: IQuestionConfig[]) => {
      return questions.filter(question => {
        const scoringConfig = this.itemBankCtrl.getQuestionScoringInfo(question.id);
        if (scoringConfig.is_human_scored) {
          let scales = scoringConfig.scales;
          if (typeof scales === 'string') {
            try {
              scales = JSON.parse(scales);
            } catch (e) {
              scales = []
            }
          }
          if (typeof scales === 'string') {
            return true;
          }
        }
        return false
      })
    },

    [ECheckFunctionIds.MISALIGNED_IRT_SCALE_CODE]: async (questions: IQuestionConfig[], params) => {
      const {validScales} = params;
      return questions.filter(question => {
        const scoringConfig = this.itemBankCtrl.getQuestionScoringInfo(question.id);
        if (scoringConfig.is_human_scored) {
          let scales = scoringConfig.scales;
          if (typeof scales === 'string') {
            try {
              scales = JSON.parse(scales);
            } catch (e) {
              scales = []
            }
          }
          scales?.every(scale => {
              const scaleCode = this.itemBankCtrl.getScoringScaleById(scale.score_profile_id)?.item_register_scale_code;
              return validScales?.includes(scaleCode);
          });
        }
        return false
      })
    },

  }
  // This is a function used to initialize all audits so that both audits done through custom logic and audits done through the data structure can work together
  async initAudits(){
    if(!this.audits){
      this.audits = await this.auth.apiFind(this.routes.TEST_AUTH_AUDIT_CONFIG);
    }
    
    this.customIterators['IP_RIGHTS'] = async (auditResultsModel:AuditResultCore) => {

      const {questions, checkIds, auditResults, auditResultsMap} = auditResultsModel;

      enum CheckId {
        NOT_COMPLETED = 'NOT_COMPLETED', 
        NOT_INCLUDED_EN = 'NOT_INCLUDED_EN',
        NOT_INCLUDED_FR = 'NOT_INCLUDED_FR',
        ALLOWED_IMPRESSIONS_NUM = 'ALLOWED_IMPRESSIONS_NUM' 
      };

      let assetIdSet = new Set<number>();
      let thisAssessmentAssetSet = new Set<number>();
      const elementsWithoutAssetIdMapEn = new Map<IQuestionConfig, IContentElement[]>();
      const elementsWithoutAssetIdMapFr = new Map<IQuestionConfig, IContentElement[]>();
      let elementsWithoutAssetIdEn: IQuestionConfig[] = [];
      let elementsWithoutAssetIdFr: IQuestionConfig[] = [];
      const getAssetIds = (
          elements: IContentElement[], 
          root: IQuestionConfig, 
          assetSet: Set<number>, 
          noAssetIdMap: Map<IQuestionConfig, IContentElement[]>
      ) => {
        if (root.assetId) {
          assetSet.add(root.assetId);
        }
        if (elements) {
          for(const element of elements) {
            if(element.assetId) {
              assetSet.add(element.assetId);
            } else if (element.url && ['image','video','audio'].indexOf(element.elementType) !== -1) {
              let list = noAssetIdMap.get(root);
              if (!list) { list = []; noAssetIdMap.set(root, list)}
              //console.log(`no assetId for elementType "${element.elementType}" with URL: ${element.url} in question ${root.id}`);
              list.push(element);
            }
            getAssetIds(getElementChildren(element), root, assetSet, noAssetIdMap);
          }
        }
      }
      // limit to the assessment scope
      const questionStructs = questions.map(q => {return {
        root: q, 
        contentEn: this.getQuestionContent(q, 'en'), 
        contentFr: this.getQuestionContent(q, 'fr')
      }});
      for(const entry of questionStructs) {
        getAssetIds(entry.contentEn, entry.root, assetIdSet, elementsWithoutAssetIdMapEn);
        getAssetIds(entry.contentFr, entry.root, assetIdSet, elementsWithoutAssetIdMapFr);
      }
      elementsWithoutAssetIdEn = Array.from(elementsWithoutAssetIdMapEn.keys());
      elementsWithoutAssetIdFr = Array.from(elementsWithoutAssetIdMapFr.keys());
      auditResultsMap.get(CheckId.NOT_INCLUDED_EN).items = elementsWithoutAssetIdEn;
      auditResultsMap.get(CheckId.NOT_INCLUDED_FR).items = elementsWithoutAssetIdFr;
      const data = await this.auth.apiFind(this.routes.TEST_AUTH_ASSET, {})
      const assets: ILibraryAsset[] = data.data.filter(d => Array.from(assetIdSet).includes(d.asset_id));
      // CheckId.NOT_COMPLETED
      assets.forEach(asset => {
        if (asset.status !== EStatus.COMPLETED) {
          auditResultsMap.get(CheckId.NOT_COMPLETED)?.items?.push(asset.asset_id)
        }
        if (asset.num_print_impressions && parseInt(asset.num_print_impressions) < asset.totalTestTakers && thisAssessmentAssetSet.has(asset.asset_id)) {
          auditResultsMap.get(CheckId.ALLOWED_IMPRESSIONS_NUM)?.items?.push(asset.asset_id)
        }
      });

      return {}
    }
    
    this.customIterators['PRINT_VERSION'] = async (auditResultsModel:AuditResultCore) => {

      const {questions, checkIds, auditResults, auditResultsMap} = auditResultsModel;

      enum CheckId {
        PRINT_FRIENDLY = 'PRINT_FRIENDLY',
      };

      let questionSet = new Set<IQuestionConfig>();
      const isElementPrintFriendly = (element: IContentElement): boolean => {
        let isPrintFriendly = true;
        if (element.elementType) {
          const typeDef = ElementTypeDefs[element.elementType.toUpperCase()];
          if (typeDef) {
            if (typeof typeDef.isPrintFriendly !== 'undefined') {
              isPrintFriendly = typeDef.isPrintFriendly;  
            } else { // special cases
                if (
                  (element.elementType === ElementType.INPUT && element.format === InputFormat.TEXT) ||
                  (element.elementType === ElementType.MCQ && element.displayStyle === McqDisplay.DROPDOWN) ||
                  (element.elementType === ElementType.TEXT && element.paragraphStyle === TextParagraphStyle.ANNOTATION)  
                ) {
                  isPrintFriendly = false;
                }
            }
          }
        }
        return isPrintFriendly;
      }
      const checkPrintFriendlyElements = (question: IQuestionConfig, elements: IContentElement[]) => {
        if (elements) {
          for(const element of elements) {
            if (!isElementPrintFriendly(element)) {
              questionSet.add(question)
            }
            checkPrintFriendlyElements(question, getElementChildren(element));
          }
        }
      }
      questions.forEach(question => {
        checkPrintFriendlyElements(question, this.getQuestionContent(question));
      })
      auditResultsMap.get(CheckId.PRINT_FRIENDLY).items = Array.from(questionSet);

      return {}
    }

    this.customIterators['COMMON_ITEMS'] = async (auditResultsModel:AuditResultCore) => {

      const {auditSlug, questions, checkIds, auditResults, auditResultsMap} = auditResultsModel;

      enum CheckId {
        COMMON_ITEMS = 'COMMON_ITEMS',
      }

      // phasing this out, but want to have a warning in case items are being skipped
      const questionsOld = this.itemBankCtrl.frameworkCtrl.getLinearFormQuestions()
      const questionIds = new Set(questions.map(q => q.id));
      const questionsMissed = questionsOld.filter(q => !questionIds.has(q.id));
      if (questionsMissed.length){
        console.warn('COMMON_ITEMS audit might be skipping some items. This may require developer investigation. Item discrepancy:', questionsMissed)
      }
      
      const groupid = this.itemBankCtrl.saveLoadCtrl.getGroupID().toString()
      //console.log(thisAssessment)
      if (!groupid) return;
      const res = await this.auth.apiGet(this.routes.TEST_AUTH_FRAMEWORKS_AUDIT, parseInt(groupid))
      const seenItemIds = new Map()
      const alreadyDuped = new Map()
      for (let i = 0;res[i];i++) {
        const frmwrk = JSON.parse(res[i]["framework"])
        if (!frmwrk) {
          continue;
        }
        const frameworkCopy = <ItemSetFrameworkCtrl>{...this.frameworkCtrl, asmtFmrk: frmwrk}
        const ctx = {itemBankCtrl:this.itemBankCtrl, lang: this.lang.c(), frameworkCtrl:frameworkCopy}
        const questions = await getScreens(ctx)
        for (let q of questions) {
          const id = q.id
          if (id && seenItemIds.get(id) && !alreadyDuped.get(id)) {
            alreadyDuped.set(id, true)
          }
          seenItemIds.set(id, true)
        }
      }
      const totalQuestions = []
      for (let i = 0;i<questions.length;i++) {
        const item = questions[i]
        if (alreadyDuped.has(item.id)) {
          totalQuestions.push(item)
        }
      }
      this.auditQuestionMem[auditSlug] = totalQuestions
      auditResultsMap.get(CheckId.COMMON_ITEMS)?.items?.push(...totalQuestions)

      return {}
    }

    
    this.customIterators['TRAX_PARAM'] = async (auditResultsModel:AuditResultCore) => {
      
      const {questions, checkIds, auditResults, auditResultsMap} = auditResultsModel;

      enum CheckId {
        ASMT_SESS_NUM = 'ASMT_SESS_NUM' ,
        ASMT_CODE = 'ASMT_CODE' ,
        ASMT_MARK = 'ASMT_MARK' ,
        ASMT_SCALE = 'ASMT_SCALE' ,
        ASMT_SESS_CHAR = 'ASMT_SESS_CHAR' 
      }
  
      questions.forEach((item:IQuestionConfig)=>{
        let asmt_session_numbers = false
        let assmt_code = false
        let mark_value = false
        let scale_factor = false
        let asmt_session_char = false;
        function isDigit(c) {
          return c>='0' && c<='9'
        }
        function isChar(c) {
          return (c>='a' && c<='z') || (c>='A' && c<='Z')
        }
        if (item.meta) {
          const assmt_sess = (item.meta["ASSMT_SESSION"])
          const code = (item.meta["ASSMT_CODE"])
          const mark = (item.meta["MARK_VALUE"])
          const scale = (item.meta["SCALE_FACTOR"])
          const section = (item.meta["ASSMT_SECTION"])
          if (assmt_sess) {
            if (assmt_sess.length==6) {
              asmt_session_numbers = true
              for (let i = 0;i<6;i++) {
                if (!isDigit(assmt_sess.charAt(i))) {
                  asmt_session_numbers = false
                }
              }
            }
          }
          if (code) {
            if (code.length==5) {
              assmt_code = true
              for (let i = 0;i<3;i++) {
                const c = code.charAt(i)
                if (!isChar(c)) {
                  assmt_code = false
                }
              }
              for (let i = 3;i<5;i++) {
                const c = code.charAt(i)
                if (!isDigit(c)) {
                  assmt_code = false
                }
              }
            }
          } 
          if (mark) {
            if (mark.length>0 && mark.length<3) {
              mark_value = true;
              for (let i = 0;i<mark.length;i++) {
                if (!isDigit(mark.charAt(i))) {
                  mark_value = false
                }
              }
            }
          }
          if (scale) {
            if (scale.length>0 && scale.length<9) {
              scale_factor = true;
              for (let i = 0;i<scale.length;i++) {
                if (!isDigit(scale.charAt(i))) {
                  scale_factor = false
                }
              }
            }
          }
          if (section && section.length>0) {
            const c = section.charAt(0)
            if (c=='A' || c=='B') {
              asmt_session_char = true
            }
          }
        }
        if (!asmt_session_numbers) auditResultsMap.get(CheckId.ASMT_SESS_NUM)?.items?.push(item)
        if (!assmt_code) auditResultsMap.get(CheckId.ASMT_CODE)?.items?.push(item)
        if (!mark_value) auditResultsMap.get(CheckId.ASMT_MARK)?.items?.push(item)
        if (!scale_factor) auditResultsMap.get(CheckId.ASMT_SCALE)?.items?.push(item)
        if (!asmt_session_char) auditResultsMap.get(CheckId.ASMT_SESS_CHAR)?.items?.push(item)
      })

      return {}
    }
    
    this.customIterators['MULTIMEDIA_ASSET_AUDIT'] = async (auditResultsModel: AuditResultCore) => {
      enum CheckId{
        GET_TOTAL_MULTI_MEDIA_COUNT_AND_FILESIZE = 'GET_TOTAL_MULTI_MEDIA_COUNT_AND_FILESIZE',
      }
      const size_limit = parseInt(prompt("Enter in kilobytes the total file size you want to flag items based on:"));
      if(!size_limit || size_limit < 1){
        this.alert('Please enter a value greater than 1 KB');
        throw new Error();
      }

      const {auditSlug,checkIds, auditResultsMap} = auditResultsModel;
      const {questions} = this.itemBankCtrl;
      const assetResults = await this.getAssetResults(questions)
      let remodeledResults;
      for(let checkId of checkIds){
        if(checkId === CheckId.GET_TOTAL_MULTI_MEDIA_COUNT_AND_FILESIZE){
          remodeledResults = this.remodeledData(assetResults,size_limit);
          this.auditQuestionMem[auditSlug] = remodeledResults;
          this.auditResultHeader[auditSlug] = `${checkId} - Total Size Limit set to ${size_limit} KB`;
          auditResultsMap.get(checkId)?.items?.push(...remodeledResults);
        } 
      }
      
      this.markAuditAsRan(auditSlug, false, true, auditResultsMap);
      return {isCustomResults: true};
    }
  }

  async getCachedValue<K extends ECheckCache>(cacheId: K, data?: any): Promise<TCheckCacheType[K]>{
    let questions:IQuestionConfig[];
    switch(cacheId){
      case ECheckCache.CLONED_QUESTION_REF:
        if(this.checkFunctionCache[ECheckCache.CLONED_QUESTION_REF]) return this.checkFunctionCache[ECheckCache.CLONED_QUESTION_REF] as TCheckCacheType[K];
        else {
          const questions =  await getQuestionsByScope(AuditQuestionScope.ITEM_BANK, this.getContext())
          const clonedQuestionsRef = new Set<string>();
          const seenQuestionsRef = new Set<string>();
          questions.forEach(question => {
          const labelCore = getCloneLabelCore(question.label);
          if (seenQuestionsRef.has(labelCore)) {
            clonedQuestionsRef.add(labelCore);
          }
          seenQuestionsRef.add(labelCore);
          });
          this.checkFunctionCache[ECheckCache.CLONED_QUESTION_REF] = clonedQuestionsRef;
          return clonedQuestionsRef as TCheckCacheType[K];
        }
      case ECheckCache.UNRESOLVED_COMMENTS:
        questions = data;
        if(this.checkFunctionCache[ECheckCache.UNRESOLVED_COMMENTS]) return this.checkFunctionCache[ECheckCache.UNRESOLVED_COMMENTS] as TCheckCacheType[K];
        const assetIdArr = this.getAssetIds(questions)
        const res = await this.auth.apiGet(this.routes.TEST_AUTH_NOTES_AUDIT, this.itemBankCtrl.customTaskSetId, {query: {
              assetIds: assetIdArr
            }});
        this.checkFunctionCache[ECheckCache.UNRESOLVED_COMMENTS] = {unresolvedAssetIds: res.unresolvedAssetIds.map(a => a.id), unresolvedQIds: res.unresolvedQIds.map(q => q.id)};
        return this.checkFunctionCache[ECheckCache.UNRESOLVED_COMMENTS] as TCheckCacheType[K];
      case ECheckCache.TESTLETS_BY_QUESTION_ID:
        if(this.checkFunctionCache[ECheckCache.TESTLETS_BY_QUESTION_ID]) return this.checkFunctionCache[ECheckCache.TESTLETS_BY_QUESTION_ID] as TCheckCacheType[K];
        const testletByQuestionId = new Map<number, IQuadrantTestlet[]>();
        for (const testlet of this.frameworkCtrl.asmtFmrk.testlets.filter(t => !t.isDisabled)) {
          if (testlet.questions) {
            for (const q of testlet.questions) {
              if (!testletByQuestionId.has(q.id)) {
                testletByQuestionId.set(q.id, []);
              }
              testletByQuestionId.get(q.id).push(testlet);
            }
          }
        }
        this.checkFunctionCache[ECheckCache.TESTLETS_BY_QUESTION_ID] = testletByQuestionId;
        return testletByQuestionId as TCheckCacheType[K];
      case ECheckCache.EXPECTED_ANSWER:
        if(this.checkFunctionCache[ECheckCache.EXPECTED_ANSWER]) return this.checkFunctionCache[ECheckCache.EXPECTED_ANSWER] as TCheckCacheType[K];
        questions = this.itemBankCtrl.getItems().map(q => getQuestionByLang(q, this.lang.c())).filter(q => checkQuestionInScope(q, AuditQuestionScope.ITEMS_SCORED_MINUS_HS, this.getContext()));
        this.checkFunctionCache[ECheckCache.EXPECTED_ANSWER] = await this.itemEditCtrl.mapAllExpectedAnswer(questions.map(q => q.id));
        return this.checkFunctionCache[ECheckCache.EXPECTED_ANSWER] as TCheckCacheType[K]
      case ECheckCache.ITEM_META_MAP:
        if(this.checkFunctionCache[ECheckCache.ITEM_META_MAP]) return this.checkFunctionCache[ECheckCache.ITEM_META_MAP] as TCheckCacheType[K];
        questions = this.itemBankCtrl.getItems().map(q => getQuestionByLang(q, this.lang.c()));
        const questionMetaMap = new Map<number, object>();
        questions.forEach(q =>{
          questionMetaMap.set(q.id, q.meta)
        })
        this.checkFunctionCache[ECheckCache.ITEM_META_MAP] = questionMetaMap;
        return this.checkFunctionCache[ECheckCache.ITEM_META_MAP] as TCheckCacheType[K];
      case ECheckCache.SCORE_CATEGORIES:
        if(this.checkFunctionCache[ECheckCache.SCORE_CATEGORIES]) return this.checkFunctionCache[ECheckCache.SCORE_CATEGORIES] as TCheckCacheType[K];
        questions = this.itemBankCtrl.getItems().map(q => getQuestionByLang(q, this.lang.c())).filter(q => checkQuestionInScope(q, AuditQuestionScope.ITEMS_SCORED_MINUS_HS, this.getContext()));
        this.checkFunctionCache[ECheckCache.SCORE_CATEGORIES] = await this.itemEditCtrl.mapAllScoreCategories(questions.map(q => q.id));
        return this.checkFunctionCache[ECheckCache.SCORE_CATEGORIES] as TCheckCacheType[K]
      case ECheckCache.EXISTING_BOOKMARKS_MAP:
        if (this.checkFunctionCache[ECheckCache.EXISTING_BOOKMARKS_MAP]) return this.checkFunctionCache[ECheckCache.EXISTING_BOOKMARKS_MAP] as TCheckCacheType[K];
        const regexBookMarks = /<\s*bookmark\s+id\s*=\s*"(.*?)"\s*>/g;
        const existingBookmarksMap = new Map<string, string[]>();
        this.checkFunctionCache[ECheckCache.EXISTING_BOOKMARKS_MAP] = existingBookmarksMap;
        questions = this.itemBankCtrl.getItems().map(q => getQuestionByLang(q, this.lang.c())).filter(q => checkQuestionInScope(q, AuditQuestionScope.SCREENS_PASSAGES, this.getContext()));
        questions.forEach(passage => {
          const label = passage.label.trim();
          existingBookmarksMap.set(label, []);
          const elements = getQuestionDeepElements(passage);
          elements.forEach(el => {
            if (el.elementType === ElementType.TEXT && el.paragraphStyle === TextParagraphStyle.PARAGRAPHS) {
              let match;
              el.paragraphList.forEach(paragraph => {
                while ((match = regexBookMarks.exec(paragraph.caption)) !== null) {
                  existingBookmarksMap.get(label).push(match[1]);
                }
              })
            }
            if (el.elementType === ElementType.PASSAGE) {
              let match;
              while ((match = regexBookMarks.exec(el['text'])) !== null) {
                existingBookmarksMap.get(label).push(match[1]);
              }
            }
          })
        });
        return this.checkFunctionCache[ECheckCache.EXISTING_BOOKMARKS_MAP] as TCheckCacheType[K];
    }

  }

  private isScoredResponse(block: IContentElement): block is IContentElement & IScoredResponse {
    return 'scoreWeight' in block;
  }

  /**
   * Returns an array of duplicate objects from the input array, based on a specified key.
   * @param arr Array of objects to check for duplicates.
   * @param key The key to compare for equality.
   */
  getDuplicatesByKey(arr: any[], key: string): any[] {
    const seen = new Map<any, any[]>();

    for (const item of arr) {
      const val = item?.[key];
      if (!seen.has(val)) {
        seen.set(val, []);
      }
      seen.get(val)!.push(item);
    }

    return [].concat(
      ...Array.from(seen.values())
        .filter(group => group.length > 1)
    );
  }


  /**
   * Gets question content
   * @param question 
   * @param lang 'en' | 'fr' usually none as audits adjust for language
   * @returns 
   */
  private getQuestionContent(question: IQuestionConfig, lang?: string) {
    return getQuestionContent(question, lang)
  }

  // private isRejectedItem(qConfig: IQuestionConfig) {
  //   if(qConfig?.meta){
  //     return !!qConfig.meta?.['REJ']
  //   }
  //   return false;
  // }

  private async processDraggableElements(element: IContentElementDndDraggable, results: IAssetResult[]) {
    let totalSize = 0;
    let totalImageSize = 0;
    let totalAudioSize = 0;
    const { element: contentElement } = element
    if (contentElement.elementType === ElementType.IMAGE) {
      const { image }: { image: IContentElementImage } = contentElement.images.default;
      const assetSize = await getAssetSize(image?.url);
      results.push({ url: image.url, size: Math.round(assetSize * 100) / 100, entryId: image.entryId, type: ElementType.IMAGE });
      totalSize += assetSize;
      totalImageSize += assetSize;
    }
    if (contentElement.voiceover?.url) {
      const assetSize = await getAssetSize(contentElement.voiceover.url);
      results.push({ url: contentElement.voiceover.url, size: Math.round(assetSize * 100) / 100, entryId: contentElement.voiceover.entryId, type: ElementType.AUDIO });
      totalSize += assetSize;
      totalAudioSize += assetSize;
    }
    if (element.voiceover?.url) {
      const assetSize = await getAssetSize(element.voiceover.url);
      results.push({ url: element.voiceover.url, size: Math.round(assetSize * 100) / 100, entryId: element.voiceover.entryId, type: ElementType.AUDIO });
      totalSize += assetSize;
      totalAudioSize += assetSize;
    }
    return { totalSize, totalImageSize, totalAudioSize };
  }


  private async processMcQOptions(option: IContentElementMcqOption, results: IAssetResult[]) {
    let totalSize = 0;
    let totalImageSize = 0;
    let totalAudioSize = 0;
    if (option.elementType === ElementType.IMAGE) {
      const assetSize = await getAssetSize(option?.url);
      results.push({ url: option.url, size: Math.round(assetSize * 100) / 100, entryId: option.entryId, type: ElementType.IMAGE });
      totalSize += assetSize;
      totalImageSize += assetSize;
    }
    if (option.voiceover?.url) {
      const assetSize = await getAssetSize(option.voiceover.url);
      results.push({ url: option.voiceover.url, size: Math.round(assetSize * 100) / 100, entryId: option.voiceover.entryId, type: ElementType.AUDIO });
      totalSize += assetSize;
      totalAudioSize += assetSize;
    }
    return { totalSize, totalImageSize, totalAudioSize };
  }


  private async processContentElement(content: IContentElementTemplate | IContentElementMcq | IContentElement, results: IAssetResult[]) {
    let totalSize = 0;
    let totalImageSize = 0;
    let totalAudioSize = 0;

    if (content.elementType === ElementType.IMAGE) {
      const { image }: { image: IContentElementImage } = content.images.default;
      const assetSize = await getAssetSize(image.url);
      results.push({ url: image.url, size: Math.round(assetSize * 100) / 100, entryId: image.entryId, type: ElementType.IMAGE });
      totalSize += assetSize;
      totalImageSize += assetSize;
    }

    if (content.voiceover?.url) {
      const assetSize = await getAssetSize(content.voiceover.url);
      results.push({ url: content.voiceover.url, size: Math.round(assetSize * 100) / 100, entryId: content.voiceover.entryId, type: ElementType.AUDIO });
      totalSize += assetSize;
      totalAudioSize += assetSize;
    }

    if (content.elementType === ElementType.MCQ) {
      if (Array.isArray((content as IContentElementMcq).options)) {
        for (let option of (content as IContentElementMcq).options) {
          const { totalSize: optionTotalSize, totalImageSize: optionTotalImageSize, totalAudioSize: optionTotalAudioSize } = await this.processMcQOptions(option, results);
          totalSize += optionTotalSize;
          totalImageSize += optionTotalImageSize;
          totalAudioSize += optionTotalAudioSize;
        }
      }
    }
    if (content.elementType === ElementType.GROUPING) {
      if (Array.isArray((content as IContentElementGroup).draggables)) {
        for (let element of (content as IContentElementGroup).draggables) {
          const { totalSize: draggableTotalSize, totalImageSize: draggableTotalImageSize, totalAudioSize: draggableTotalAudioSize } = await this.processDraggableElements(element, results);
          totalSize += draggableTotalSize;
          totalImageSize += draggableTotalImageSize;
          totalAudioSize += draggableTotalAudioSize;

        }
      }
    }
    if (content.elementType === ElementType.TEMPLATE || content.elementType === ElementType.FRAME) {
      if (Array.isArray(content["content"])) {
        for (let element of content["content"]) {
          const { totalSize: nestedElTotalSize, totalImageSize: nestedElTotalImageSize, totalAudioSize: nestedElTotalAudioSize } = await this.processContentElement(element, results);
          totalSize += nestedElTotalSize;
          totalImageSize += nestedElTotalImageSize;
          totalAudioSize += nestedElTotalAudioSize;

        }
      }
    }
    return { totalSize, totalImageSize, totalAudioSize };
  }

  private async getQuestionExpectedAnswer(id: number, lang: string){
    return (await this.itemEditCtrl.findAllExpectedAnswer(id))?.filter(ea => ea.lang === lang);
  }

  private async getScoreCategories(id: number): Promise<IQuestionScoreCategory>{
    return (await this.auth.apiGet(this.routes.DATA_EXPORTER_PSYCH_ITEM_SCORE_CATEGORIES, id));
  }

  private async getAssetResults(questions: IQuestionConfig[]): Promise<Map<string, IQuestionResult>> {
    const assetResult = new Map<string, IQuestionResult>();
    await Promise.all(questions.map(async q => {
      const qContent = await this.getQuestionContent(q);
      const results: IAssetResult[] = [];
      let totalSize = 0;
      let totalImageSize = 0;
      let totalAudioSize = 0;
      for (let content of qContent) {
        const { totalSize: contentTotalSize, totalImageSize: contentTotalImageSize, totalAudioSize: contentTotalAudioSize } = await this.processContentElement(content, results);
        totalSize += contentTotalSize;
        totalImageSize += contentTotalImageSize;
        totalAudioSize += contentTotalAudioSize;
      }
      if (q.voiceover?.url) {
        const assetSize = await getAssetSize(q.voiceover.url);
        results.push({ url: q.voiceover.url, size: Math.round(assetSize * 100) / 100, entryId: q.voiceover.entryId, type: "Question Voice-Over" });
        totalSize += assetSize;
        totalAudioSize += assetSize;
      }
      if (results.length > 0) {
        assetResult.set(`${q.id} - ${q.label}`, { qid: q.id, results, imageSize: Math.round(totalImageSize * 100) / 100, audioSize: Math.round(totalAudioSize * 100) / 100, totalSize: Math.round(totalSize * 100) / 100 });
      }
    }));

    return assetResult;
  }


  remodeledData(imageResults: Map<string, IQuestionResult>, sizeLimit: number){
    const remodeledResults = Array.from(imageResults.entries()).map(([label,value]) => {
      const content: IExpansionPanelContent[] = [
        { type: ExpansionPanelContentType.JSON_VIEW,label: `Total Size = ${value.totalSize} KB; Total Image Size = ${value.imageSize} KB; Total Audio Size = ${value.audioSize} KB`,
         data: value.results.map((result) => { return { type:`${result.type}`,id: `${result.entryId}`, size:`${result.size} KB`,url:`${result.url}`  } }) }]
      const greaterThanSize = (value.totalSize > sizeLimit) ? true : false

      return {
        title: `${label}`,
        subTitle: `Total Files = ${value.results.length}`,
        content,
        greaterThanSize,
        style: {'border':`solid 0.1em ${greaterThanSize ? 'orange' : 'green'}`}
      }
    })
    return remodeledResults;
  }

  resetAudits(){
    this.auditQuestionMem = [];
    this.auditLogs = [];
    this.excludedAuditMap = {}; // Clear excluded audits when resetting audits
    // this.clearAuditItemPreview();
  }

  retrievingAuditLogs
  getAuditLogs(itemId?:number) {
    this.retrievingAuditLogs = true;
    this.auditLogs = [];
    let overAllMem: Partial<AuditMetaRecord> = {};
    if(itemId){
      this.runningItemLevelAuditId = itemId;
      this.auditQuestionMem[this.getAuditResultSlug(itemId, AuditResultType.OVERALL)] = overAllMem;
    } else {
      this.runningFrameworkLevelAuditId = +this.itemBankCtrl.customTaskSetId;
      this.auditQuestionMem[this.getAuditResultSlug(this.itemBankCtrl.customTaskSetId, AuditResultType.OVERALL)] = overAllMem;
    }
    this.auth.apiGet(this.routes.TEST_AUTH_ITEM_SET_AUDITS, this.itemBankCtrl.customTaskSetId, 
      { query: {
          lang: this.lang.getCurrentLanguage(),
          item_id: itemId
      }}).then((res) => {
        const latestDesignDate = this.frameworkCtrl.publishingCtrl.testDesignReleaseHistory?.[0] ? 
          new Date(this.frameworkCtrl.publishingCtrl.testDesignReleaseHistory?.[0]?.created_on) :
          null;
        Promise.all(res.map(async (log) => {
          // Skip excluded audits
          if (this.excludedAuditMap?.[log.audit_slug]?.isExcluded) {
            return;
          }
          
          const logDate = new Date(log.audited_on);
          log.is_new = !latestDesignDate || logDate > latestDesignDate;
      
          if (log.results_link) {
            try {
              const response = await fetch(log.results_link);
              const {results} = await response.json();
              delete log.results_link;
              if(typeof results && results?.length){
                // Filter out hidden results before processing metadata
                const filteredResults = results.filter(result => !this.excludedAuditMap?.[log.audit_slug]?.excludedChecks[result.id ?? result.key]);
                const audit = this.getAuditBySlug(log.audit_slug);
                const auditType = audit?.auditType;
                if(auditTypeWithoutSummary.has(auditType) || !audit){
                  return;
                }
                // Recalculate metadata based on visible results only
                const filteredMetaData = {pass: 0, fail: 0, informative: 0};
                filteredResults.forEach(result => {
                  let count = result.items?.length || result.num_issues 
                  // If itemId is present, cap count at as were doing it at the item level
                  if (itemId && count > 1) count = 1;
                  if (!count) filteredMetaData.pass++;
                  else if (result.informativeOnly) filteredMetaData.informative += count;
                  else filteredMetaData.fail += count;
                });
                
                filteredResults.__metaData = filteredMetaData;
                
                this.auditQuestionMem[this.getAuditResultSlug(log.audit_slug)] = filteredResults;
                filteredResults.forEach(result => {
                  this.auditQuestionMem[log.audit_slug + '_' + result.id] = result.items
                })
                // Update overall metrics with filtered counts
                  // Update overall metrics with filtered counts, grouped by auditType
  
                  if (!overAllMem[auditType]) {
                  overAllMem[auditType] = { pass: 0, fail: 0, informative: 0};
                  }
                  if(log.audited_on){
                    const { firstRan, lastRan} = overAllMem[auditType];
                    overAllMem[auditType].firstRan = Math.min(firstRan ?? Infinity, logDate.getTime())
                    overAllMem[auditType].lastRan = Math.max(lastRan ?? -Infinity, logDate.getTime())
                  }
                  overAllMem[auditType].pass += filteredMetaData.pass ?? 0;
                  overAllMem[auditType].fail += filteredMetaData.fail ?? 0;
                  overAllMem[auditType].informative += filteredMetaData.informative ?? 0;
                  this.auditLogs.push({...log, auditType});
              }
            } catch (error) {
              console.warn("Fetch error:", error, log.audit_slug);
              return;  // Continue processing the next log
            }
          }
      
        })).then(() =>{
          if(itemId){
            this.finishProcessingItemLevelAudit();
          } else {
            this.finishProcessingFrameworkLevelAudit();
          }
          this.auditRanSub.next('');
        }).finally(() =>{
          this.retrievingAuditLogs = false;
          this.auditsMetadataUpdated.next(true);
        })
    })
  }

  get frameworkAuditQuestionMem(): Partial<AuditMetaRecord> {
    return this.auditQuestionMem[this.getAuditResultSlug(this.itemBankCtrl.customTaskSetId, AuditResultType.OVERALL)];
  }
  get auditStatus(): IAuditResultSummary {
    return aggregateAuditMetaRecords(this.frameworkAuditQuestionMem)
  }
  get itemAuditQuestionMem(): Partial<AuditMetaRecord> {
    return this.auditQuestionMem[this.getAuditResultSlug(this.itemBankCtrl.currentQuestion?.id, AuditResultType.OVERALL)];
  }
  get itemAuditStatus(): IAuditResultSummary {
    return aggregateAuditMetaRecords(this.itemAuditQuestionMem)
  }

  finishProcessingItemLevelAudit(){
    this.runningItemLevelAuditId = null;
    this.checkFunctionCache = {};
  }

  finishProcessingFrameworkLevelAudit(){
    this.runningFrameworkLevelAuditId = null;
    this.checkFunctionCache = {};
  }

  /**
   * 
   * @param slug 
   * @param prefix 
   * @returns the slug to use in questionMem to get results of overall summarry, audit results, or check results
   */  
  getAuditResultSlug(slug: string | number, prefix: AuditResultType = AuditResultType.DEFAULT) {
    // Only include prefix if it's a non-empty string
    const parts = [];
    if (prefix) {
      parts.push(prefix);
    }
    parts.push(slug, "RESULTS");
    return parts.join('_');
  }

  getAuditLog(auditSlug: string) { //! To do make this a map
    if(this.auditLogs) {
      return this.auditLogs.find(log => log.audit_slug == auditSlug)
    } 

    return null;
  }  
  removeDuplicatesFromQuestions(questions: IQuestionConfig[]){
    return questions.filter((v,i,a)=>a.findIndex(v2=>(v2.id===v.id))===i)
  }
  private markAuditRunning(ranCode: string, isRunning: boolean){
    this.auditsRunning[ranCode] = isRunning
  }  

  private getContext() : IContext {
    return {
      lang: this.lang.c(),
      frameworkCtrl: this.frameworkCtrl,
      itemBankCtrl: this.itemBankCtrl
    }
  }

  /**
   * Retrieves the excluded audit entry for a given audit slug.
   * If the entry does not exist, it initializes it with a default value.
   * 
   * @param slug - The unique identifier for the audit.
   * @returns The excluded audit entry for the specified slug.
   */
  getExcludedAudit(slug: string): ExcludedAuditEntry {
    const defaultEntry = getDefaultExcludedAuditEntry();
    return this.excludedAuditMap[slug] ?? (this.excludedAuditMap[slug] = defaultEntry);
  }

  /**
   * Utility to count operational items (non-FT) in a given list of questions or question IDs.
   * Returns the count of items where meta['FT'] is falsey.
   *
   * @param items Array of question IDs or objects with at least an id property
   * @param excludeReadingSelection
   */
  countOperationalItems(
    items: IQuestionConfig[],
    excludeReadingSelection: boolean = false,
  ): number {
    if (!items?.length) return 0;
    // If items are numbers (IDs), resolve to question objects
    return items.map(q => getQuestionByLang(q))
      .filter(q => !!q && checkPropCondVal(q.meta?.['FT'], EFilterMethods.IS_FALSEY) && (!excludeReadingSelection || !q.isReadingSelectionPage)).length;
  }

  get FrameworkConstructionType(){
    return this.frameworkCtrl.asmtFmrk.testFormType
  }
  
  /**
   * Fetches psychometric statistics data for a list of questions in parallel
   * @param questions Array of question configurations
   * @returns Promise resolving to Map with question ID as key and psych stats data as value
   */
  private fetchPsychStatsData(questions: IQuestionConfig[]): Map<number, any> {
    const metaPromises = questions.map((qConfig) => {
      try {
        const statsData = this.itemBankCtrl.getQuestionStats(qConfig)
        return { id: qConfig.id, data: statsData };
      } catch (e) {
        return { id: qConfig.id, data: {} };
      }
    });
    
    const results = metaPromises
    const psychStatsMap = new Map<number, any>();
    
    results.forEach(result => {
      psychStatsMap.set(result.id, result.data);
    });
    
    return psychStatsMap;
  }

  private getCloneLinkerParam(){
    const trackingParams = this.frameworkCtrl.identifySpecialParams(PARAM_SPECIAL_FLAGS.CLONE_LINKER);
    if (trackingParams.length === 0) {
      this.alert('This audit can only run if there is exactly one parameter that is indicated as the Clone Linker');
      // return this.auditsRan['CLONES'] = false;
      throw new Error();
    }
    if (trackingParams.length > 1) {
      this.alert('This audit is not compatible with frameworks which contain multiple Clone Linker parameters');
      // return this.auditsRan['CLONES'] = false;
      throw new Error();
    }
    return trackingParams[0]
  }

  private getAssetIds(questions:IQuestionConfig[]){
    const getAssetIds = (elements: IContentElement[], assetIdSet: Set<number>) => {
        if(!elements) {
          return;
        }
        for(const element of elements) {
          if(element.assetId) {
            assetIdSet.add(element.assetId);
          }
          getAssetIds(getElementChildren(element), assetIdSet);
        }
      }
      let assetIdSet = new Set<number>();
      const allContent = questions.map(q => {
        if (q.assetId) {
          assetIdSet.add(q.assetId)
        }
        return q.content
      });
      for(const content of allContent ) {
        getAssetIds(content, assetIdSet);
      }
      return Array.from(assetIdSet.values());
  }
}

function factorial(x:number){
  return (x > 1) ? x * factorial(x-1) : 1;
}

/**
 * Calculates all number of all combinations that contain at least one correct answer
 * @param numSelected 
 * @param options 
 * @param correct 
 * @returns 
 */
function possiblePartialCorrectMCQ(numSelected:number, options:number, correct:number){
  return posibleCombinations(options, numSelected) - posibleCombinations(options, (numSelected - correct));
}

/**
 * Calculates the number of possible combinations that can be made by choosing a specific number of items
 * from a larger set, where the order of selection does not matter.
 *
 * @param optionsAvailable The total number of distinct options available to choose from.
 * @param slots The number of items to be selected from the available options.
 * @returns The number of possible combinations=.
 */
function posibleCombinations(optionsAvailable: number, slots: number) {
  return factorial(optionsAvailable) / (factorial(slots) * factorial(optionsAvailable - slots));
}

function hasLabelType(label: string, metaType: string, type: string): boolean {
  return label.includes(`${type}`) || metaType === type;
}

function isMisaligned(label: string, metaType: string, type: string): boolean {
  return hasLabelType(label, metaType, type) && (!label.includes(`/${type}`) || metaType !== type);
}


